(() => {
  // Last tagged visit, retained for 30 days. Store only explicit campaign fields.
  const attributionKey = "pawnted_campaign_attribution_v1";
  const attributionFields = {utm_goal:80,utm_source:160,utm_medium:160,utm_campaign:200,utm_content:200,utm_term:200,campaign_id:80,adset_id:80,ad_id:80};
  const campaignParams = new URLSearchParams(location.search);
  const landingAttribution = Object.fromEntries(Object.entries(attributionFields).flatMap(([key,max]) => {
    const value = campaignParams.get(key)?.trim().slice(0,max);
    return value ? [[key,value]] : [];
  }));
  let campaignAttribution;
  try {
    if (Object.keys(landingAttribution).length) {
      campaignAttribution = landingAttribution;
      localStorage.setItem(attributionKey,JSON.stringify({at:Date.now(),values:campaignAttribution}));
    } else {
      const previous = JSON.parse(localStorage.getItem(attributionKey) || "null");
      if (previous?.at > Date.now()-30*86400000 && previous.at <= Date.now()) campaignAttribution = previous.values;
    }
  } catch { if (Object.keys(landingAttribution).length) campaignAttribution = landingAttribution; }
  document.querySelectorAll("[data-pawnted]").forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = "1";
    document.body?.classList.add("pw-pdp-page");
    const $ = (selector) => root.querySelector(selector);
    // Display-only protection: original files stay clean for fulfilment and downloads.
    const watermarkNote = document.createElement("p");
    watermarkNote.className = "pw-watermark-note";
    watermarkNote.textContent = "Your print arrives without the watermark.";
    $("[data-visual]").after(watermarkNote);
    root.querySelectorAll("[data-compare-image]").forEach(image => {
      const wrap = document.createElement("div");
      wrap.className = "pw-watermarked-comparison";
      image.before(wrap); wrap.append(image);
    });
    const isFunnel = root.dataset.funnel === "true";
    const emitted = new Set(), acceptedAt = new Map();
    const creditBadge = $("[data-credit-badge]"), creditBadgeCount = $("[data-credit-badge-count]");
    // Funnel: one "Not quite right?" sheet replaces the repeated secondary actions.
    let openOptions = () => {}, openEdit = () => {}, openRetry = () => paint();
    if (isFunnel) {
      const sheet = document.createElement("dialog");
      sheet.className = "pw-options-sheet"; sheet.dataset.optionsSheet = ""; sheet.setAttribute("aria-labelledby", "pw-options-title");
      sheet.innerHTML = '<div class="pw-options-heading"><h2 id="pw-options-title">Not quite right?</h2><button type="button" data-close-options class="pw-secondary" aria-label="Close options">Close</button></div>' +
        '<p class="pw-note">Your portraits stay saved. Pick what you would like to change.</p><div class="pw-options-list">' +
        '<button type="button" data-sheet-action="retry"><strong>Try again</strong><span>Same photos, same style. A fresh version.</span></button>' +
        '<button type="button" data-sheet-action="style"><strong>Different style</strong><span>Back to the styles. Your photos are kept.</span></button>' +
        '<button type="button" data-sheet-action="photos"><strong>Different photos</strong><span>Start again with new photos from your phone.</span></button>' +
        '<button type="button" data-sheet-action="adjust"><strong>Fix a detail</strong><span>Tell us what to change in this portrait.</span></button>' +
        '</div><p class="pw-note" data-options-cost></p><div class="pw-options-more"><button type="button" data-sheet-action="favourite" class="pw-text-button"></button><button type="button" data-sheet-action="compare" class="pw-text-button">Compare side by side</button><button type="button" data-sheet-action="library" class="pw-text-button">Your portraits</button></div>';
      root.append(sheet);
      const mobileOptions = document.createElement("button");
      mobileOptions.type = "button"; mobileOptions.className = "pw-secondary"; mobileOptions.dataset.mobileOptions = ""; mobileOptions.hidden = true; mobileOptions.textContent = "Upload new photos";
      $("[data-mobile-action]").before(mobileOptions);
      const reviewOptions = document.createElement("button");
      reviewOptions.type = "button"; reviewOptions.className = "pw-secondary"; reviewOptions.dataset.reviewOptions = ""; reviewOptions.textContent = "Upload new photos";
      $("[data-approve]").after(reviewOptions);
      // Combined preview-and-print screen: under Add to cart, one way on to another style and one way to fix this portrait.
      const anotherStyle = document.createElement("button");
      anotherStyle.type = "button"; anotherStyle.className = "pw-secondary"; anotherStyle.dataset.createAnotherStyle = ""; anotherStyle.textContent = "Create another style";
      anotherStyle.onclick = () => { if (busy || pending) return; return window.PawntedFunnel?.showStyles ? window.PawntedFunnel.showStyles() : openStyles(); };
      const buyOptions = document.createElement("button");
      buyOptions.type = "button"; buyOptions.className = "pw-text-button"; buyOptions.dataset.buyOptions = ""; buyOptions.textContent = "Upload new photos";
      buyOptions.onclick = editPhotos;
      ($(".pw-delivery-note") || $("[data-cart]")).after(anotherStyle, buyOptions);
      const pencil = document.createElement("button");
      pencil.type = "button"; pencil.className = "pw-edit-pencil"; pencil.dataset.editPencil = ""; pencil.hidden = true; pencil.setAttribute("aria-label", "Describe a change to this portrait");
      pencil.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg><span>Request changes</span>';
      // Describing a change happens in a modal over the portrait: the page underneath never moves.
      const editDialog = document.createElement("dialog");
      editDialog.className = "pw-edit-dialog"; editDialog.dataset.editDialog = ""; editDialog.setAttribute("aria-labelledby", "pw-edit-title");
      editDialog.innerHTML = '<div class="pw-options-heading"><h2 id="pw-edit-title">Describe your change</h2><button type="button" data-close-edit class="pw-edit-close" aria-label="Close">\u00d7</button></div>';
      editDialog.append($(".pw-change")); root.append(editDialog);
      $(".pw-change textarea").placeholder = "For example: Make the cat's fur darker, keep the white chest, and remove the collar.";
      const closeEdit = () => { if (editDialog.close) editDialog.close(); else editDialog.removeAttribute("open"); };
      openEdit = () => {
        if (busy || pending || !completed) return;
        $(".pw-change").hidden = false;
        if($("[data-edit-target]")?.dataset.source !== portraitId) {
          if($("[data-edit-target-label]"))$("[data-edit-target-label]").hidden=true;
          if($("[data-edit-plan-message]"))$("[data-edit-plan-message]").textContent="";
        }
        if (editDialog.showModal) editDialog.showModal(); else editDialog.setAttribute("open", "");
        $(".pw-change textarea").focus({preventScroll: true});
      };
      editDialog.querySelector("[data-close-edit]").onclick = closeEdit;
      editDialog.addEventListener("click", event => { if (event.target === editDialog) closeEdit(); });
      editDialog.addEventListener("close", () => { $(".pw-change").hidden = true; });
      pencil.onclick = event => { event.stopPropagation(); openEdit(); };
      // Retry sits beside Edit: same photos, same style, a fresh version.
      const retryArt = document.createElement("button");
      retryArt.type = "button"; retryArt.className = "pw-edit-pencil pw-art-retry"; retryArt.dataset.artRetry = ""; retryArt.hidden = true; retryArt.setAttribute("aria-label", "Try again with the same photos and style");
      retryArt.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20 11a8 8 0 1 0-2.3 5.7"/><path d="M20 4v7h-7"/></svg><span>Retry</span>';
      const retryDialog = document.createElement("dialog");
      retryDialog.className = "pw-edit-dialog pw-retry-dialog"; retryDialog.dataset.retryDialog = "";
      retryDialog.setAttribute("aria-labelledby", "pw-retry-title");
      retryDialog.innerHTML = '<div class="pw-retry-heading"><h2 id="pw-retry-title">Let\u2019s get it right.</h2><button type="button" data-close-retry class="pw-edit-close" aria-label="Close">&times;</button></div>' +
        '<p class="pw-retry-intro">Not quite what you imagined? Choose what happens next.</p>' +
        '<div class="pw-retry-recommended"><span class="pw-retry-label">Have a specific change?</span><h3>Tell us what to fix</h3><p>Fur colour, a missing detail, or something else? Tell us what to change and what to keep.</p><button type="button" data-retry-edit>Request changes <span aria-hidden="true">&rarr;</span></button></div>' +
        '<div class="pw-retry-alternative"><h3>Or try a fresh version</h3><p>Same photos and style, without specific changes.</p><button type="button" data-confirm-retry class="pw-secondary">Yes, retry</button></div>' +
        '<footer class="pw-retry-footer"><strong>Your current artwork stays saved.</strong><p data-retry-cost></p></footer>';
      root.append(retryDialog);
      const closeRetry = () => retryDialog.close();
      openRetry = () => {
        if (busy || pending || !completed || creditBalance?.total === 0) return;
        retryDialog.querySelector('[data-retry-cost]').textContent = 'A retry or requested edit ' + generationCost().charAt(0).toLowerCase() + generationCost().slice(1);
        if (!retryDialog.open) retryDialog.showModal();
      };
      retryDialog.querySelector('[data-close-retry]').onclick = closeRetry;
      retryDialog.addEventListener('click', event => { if (event.target === retryDialog) closeRetry(); });
      retryDialog.querySelector('[data-retry-edit]').onclick = () => { closeRetry(); openEdit(); };
      retryDialog.querySelector('[data-confirm-retry]').onclick = () => { closeRetry(); if (!busy && !pending && completed && creditBalance?.total !== 0) return paint(); };
      retryArt.onclick = event => { event.stopPropagation(); openRetry(); };
      const artActions = document.createElement("div"); artActions.className = "pw-art-actions"; artActions.append(pencil, retryArt);
      $("[data-visual]").append(artActions);
      // The view controls are gone: tapping the portrait opens it full screen.
      $(".pw-artwork-view").addEventListener("click", () => { if (completed && previewReady && !busy) $("[data-expand]").click(); });
      const closeOptions = () => { if (sheet.close) sheet.close(); else sheet.removeAttribute("open"); };
      openOptions = (creating = false) => {
        if (busy || pending || !completed) return;
        sheet.querySelector('#pw-options-title').textContent = creating ? 'What would you like to create next?' : 'Not quite right?';
        sheet.querySelector('.pw-note').textContent = creating ? 'Artwork already in your bag stays safely there. Your photos and finished portraits are kept.' : 'Your portraits stay saved. Pick what you would like to change.';
        const labels = creating ? {retry: 'Another version', style: 'Same photos, new style', photos: 'New photos'} : {retry: 'Try again', style: 'Different style', photos: 'Different photos'};
        Object.entries(labels).forEach(([action, label]) => { sheet.querySelector('[data-sheet-action="' + action + '"] strong').textContent = label; });
        sheet.querySelector('[data-sheet-action="photos"] span').textContent = creating ? 'Create another artwork with a new photo.' : 'Start again with new photos from your phone.';
        sheet.querySelector('[data-sheet-action="adjust"]').hidden = creating;
        sheet.querySelector('.pw-options-more').hidden = creating;
        const noCredits = creditBalance?.total === 0;
        sheet.querySelector('[data-sheet-action="retry"]').disabled = noCredits;
        sheet.querySelector('[data-sheet-action="adjust"]').disabled = noCredits;
        sheet.querySelector('[data-sheet-action="compare"]').hidden = recentPortraits().length < 2;
        sheet.querySelector('[data-sheet-action="favourite"]').textContent = favourites.has(portraitId) ? "♥ Saved favourite" : "♡ Save favourite";
        sheet.querySelector("[data-options-cost]").textContent = !creditBalance ? "" : noCredits ? "No previews left today. Viewing, comparing and printing stay free." : "A new version, style or fix " + generationCost().charAt(0).toLowerCase() + generationCost().slice(1);
        track("options_opened", {stage: phase});
        if (sheet.showModal) sheet.showModal(); else sheet.setAttribute("open", "");
      };
      mobileOptions.onclick = reviewOptions.onclick = editPhotos;
      sheet.querySelector("[data-close-options]").onclick = closeOptions;
      sheet.addEventListener("click", event => { if (event.target === sheet) closeOptions(); });
      sheet.querySelectorAll("[data-sheet-action]").forEach(button => button.onclick = () => {
        const action = button.dataset.sheetAction;
        if (button.disabled || busy || pending) return;
        if (action === "favourite") { toggleFavourite(portraitId); button.textContent = favourites.has(portraitId) ? "♥ Saved favourite" : "♡ Save favourite"; return; }
        closeOptions();
        if (action === "retry") return openRetry();
        if (action === "style") return window.PawntedFunnel?.showStyles ? window.PawntedFunnel.showStyles() : openStyles();
        if (action === "photos") return changePhotos();
        if (action === "library") return openLibrary();
        if (action === "compare") return $("[data-compare-versions]").onclick();
        openEdit();
      });
    }
    function track(name, detail = {}, key) {
      if (key && emitted.has(name + key)) return;
      if (key) emitted.add(name + key);
      // Only catalogue/state data: no photos, names, URLs or customer identifiers.
      try { window.Shopify?.analytics?.publish("pawnted:" + name, {style, ...detail}); } catch {}
    }
    let creditBalance = null;
    const base = root.dataset.proxy || "/apps/pawnted";
    const storageKey = "pawnted-generator-v2";
    let stored;
    try {
      stored = JSON.parse(localStorage.getItem(storageKey) || "null");
    } catch {}
    const validStored =
      stored?.visitor &&
      Number(stored.visitor.split(".")[1]) > Date.now() / 1000;
    const requestedStyle = new URLSearchParams(location.search).get("style");
    const resumeOnReload = isFunnel && root.dataset.reloadView !== "styles" && validStored && stored.phase !== "upload" &&
      performance.getEntriesByType?.("navigation")[0]?.type === "reload";
    let style = requestedStyle || stored?.style || root.dataset.style;
    let visitor = validStored ? stored.visitor : "";
    let portraitId =
      validStored && (!requestedStyle || requestedStyle === stored?.style)
        ? stored.portraitId || ""
        : "";
    let pending =
      validStored && (!requestedStyle || requestedStyle === stored?.style)
        ? stored.pending || null
        : null;
    let previousPortraitId = validStored && (!requestedStyle || requestedStyle === stored?.style)
      ? stored.previousPortraitId || "" : "";
    // A recovery link can reopen a repaired job, but never grants ownership:
    // the backend still requires this browser's valid signed visitor session.
    const recoveryId = new URLSearchParams(location.search).get("portrait");
    if (validStored && /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(recoveryId || "") && !pending) {
      portraitId = recoveryId;
      previousPortraitId = "";
    }
    let styles = [],
      variants = [],
      files = [],
      phase = "upload",
      busy = false,
      hashing = false;
    let completed = false,
      paintedName = "",
      paintedBackground = "original",
      paintedSubjectCount = "",
      approved = false,
      previewReady = false,
      sessionPromise,
      catalogPromise;
    let uploadPromise,
      uploadedPaths,
      photoRevision = 0,
      previewRevision = 0,
      rotator,
      texture = "",
      view = "artwork";
    let pollPromise,
      thumbUrls = [],
      selection = {...stored?.selection, size: "8x10"};
    const imageCache = new Map();
    const preparedCartItems = new Map();
    let prepareCartTimer = null, scheduledCartKey = "";
    let nextUploadIsFresh = false;
    let library = Array.isArray(stored?.library) ? stored.library.filter(item => item?.id && item?.style) : [];
    let favourites = new Set(Array.isArray(stored?.favourites) ? stored.favourites : []);
    let printSelections = stored?.printSelections || {};
    let reuseSourceId = stored?.reuseSourceId || "";
    let savedPhotosFor = stored?.savedPhotosFor === reuseSourceId ? reuseSourceId : "";
    let savedPhotosKept = savedPhotosFor && Array.isArray(stored?.savedPhotosKept)
      ? [...new Set(stored.savedPhotosKept.filter(index => Number.isInteger(index) && index >= 0 && index < 4))] : null;
    let renderedSavedPhotosFor = "";
    let libraryFilter = "all", libraryNext = null, libraryLoading = false;
    let librarySignature = "", styleTheme = "all", addedKey = "";
    const styleName = id => styles.find(item => item.id === id)?.name || "Your portrait";
    const cartKey = () => portraitId + ":" + (selected()?.id || "");
    function syncAddress() {
      if (!window.history?.replaceState) return;
      const address = new URL(location.href);
      address.searchParams.set("style", style); address.searchParams.delete("portrait");
      window.history.replaceState(window.history.state, "", address.pathname + address.search + address.hash);
    }
    let versions = validStored && (!requestedStyle || requestedStyle === stored?.style) && Array.isArray(stored?.versions)
      ? stored.versions.filter(item => item && typeof item.id === "string").slice(0, 64) : [];
    // A creation landing visit starts a new portrait, not an automatic purchase
    // of the last finished one. Keep saved results/photos, pending jobs and
    // explicit recovery links intact. Do this before async restoration starts.
    if (isFunnel && !resumeOnReload && !pending && !recoveryId && portraitId &&
        [...library, ...versions].some(item => item.id === portraitId)) {
      reuseSourceId = portraitId;
      portraitId = "";
      previousPortraitId = "";
      versions = [];
    }
    let historyUnavailable = false, historySignature = "";
    const backgroundSelect = $("[data-background]");
    const backgroundRadios = [...root.querySelectorAll("[data-background-swatch]")];
    const validSubjectCount = value => Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= 20;
    if (validStored && (!requestedStyle || requestedStyle === stored?.style) && stored?.customization?.background)
      backgroundSelect.value = stored.customization.background;
    const customization = () => ({ background: backgroundSelect.value || "original" });
    const artworkChanged = () => completed && ($("[data-name]").value.trim() !== paintedName || customization().background !== paintedBackground);
    function syncBackgroundSwatches() {
      if (!backgroundRadios.some(radio => radio.value === backgroundSelect.value)) backgroundSelect.value = "original";
      backgroundRadios.forEach(radio => { radio.checked = radio.value === backgroundSelect.value; });
      $("[data-background-name]").textContent = backgroundRadios.find(radio => radio.checked)?.getAttribute("aria-label") || "Original palette";
    }
    syncBackgroundSwatches();
    function restorePaintedOptions(result) {
      paintedName = result.artworkLabel ?? $("[data-name]").value.trim();
      paintedBackground = result.customization?.background || "original";
      paintedSubjectCount = validSubjectCount(result.expectedSubjectCount) ? String(result.expectedSubjectCount) : "";
      $("[data-name]").value = paintedName;
      backgroundSelect.value = paintedBackground;
      syncBackgroundSwatches();
    }
    let progressStarted = 0, progressValue = 0, progressTimer, progressFloor = 0;
    function showProgress(value) {
      progressValue = Math.max(progressValue, Math.min(100, Math.round(value)));
      $("[data-progress-value]").textContent = progressValue + "%";
      $("[data-progress]").setAttribute("aria-valuenow", String(progressValue));
      $("[data-progress]").style.setProperty("--pw-progress", progressValue);
      $("[data-progress]").setAttribute("aria-label", progressValue === 100 ? "Portrait ready" : "Estimated portrait progress");
    }
    function startProgress() {
      clearTimeout(progressTimer);
      progressStarted = Date.now(); progressValue = 0; progressFloor = 3;
      // Estimated progress; completion is confirmed only after the image loads.
      const tick = () => {
        const elapsed = (Date.now() - progressStarted) / 1000;
        // Three or four photos are painted at a higher effort, which takes longer.
        showProgress(Math.max(progressFloor, Math.min(94, 8 + 86 * (1 - Math.exp(-elapsed / (files.length >= 3 ? 50 : 22))))));
        progressTimer = setTimeout(tick, 250);
      };
      tick();
    }
    function stopProgress(ready = false) {
      clearTimeout(progressTimer); progressTimer = undefined;
      if (ready) showProgress(100);
    }
    function focusWork(target = "[data-visual]", allScreens = false) {
      // Run before any request: a tap must move the UI immediately, including
      // on slow photo uploads or when starting a new visitor session.
      const node = $(target);
      if (!node.hasAttribute("tabindex")) node.setAttribute("tabindex", "-1");
      node.focus({ preventScroll: true });
      if (allScreens || window.matchMedia?.("(max-width: 760px)").matches) {
        // Older in-app Safari versions do not all accept "instant". Override
        // the theme's smooth scrolling for this synchronous stage change.
        const pageStyle = document.documentElement.style;
        const previous = pageStyle.scrollBehavior;
        pageStyle.scrollBehavior = "auto";
        try { node.scrollIntoView({ behavior: "auto", block: "start" }); }
        finally { pageStyle.scrollBehavior = previous; }
      }
    }
    try {
      styles = JSON.parse($("[data-style-manifest]")?.textContent || "[]");
    } catch {}
    const status = (text) => {
      $(".pw-status").textContent = text || "";
      if (text) $("[data-announcement]").textContent = text;
      root.querySelectorAll("[data-generation-message]").forEach(node => {
        node.textContent = text || "";
        node.hidden = !text;
      });
    };
    const save = () => {
      try {
        localStorage.setItem(
          storageKey,
          JSON.stringify({ visitor, portraitId, previousPortraitId, style, phase, pending, selection, versions, library, favourites: [...favourites], printSelections, reuseSourceId, savedPhotosFor, savedPhotosKept, customization: customization() }),
        );
      } catch {}
    };
    const selected = () =>
      variants.find(
        (v) =>
          v.productType === $("[data-product]").value &&
          v.size === $("[data-size]").value &&
          (v.frameColor || "") === $("[data-frame]").value,
      );
    const money = (value) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(Number(value));
    const url = (path, params = {}) =>
      `${base}/${path}?${new URLSearchParams({ ...params, visitor })}`;
    const fetchBounded = async (input, options = {}, timeout = 45000) => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), timeout);
      try {
        return await fetch(input, { ...options, signal: controller.signal });
      } finally {
        clearTimeout(timer);
      }
    };
    const api = async (path, body, params) => {
      const response = await fetchBounded(
        url(path, params),
        {
          method: body === undefined ? "GET" : "POST",
          headers: { "Content-Type": "application/json" },
          ...(body === undefined ? {} : { body: JSON.stringify(body) }),
        },
        path === "restore" && body ? 90000 : 30000,
      );
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        const error = new Error(
          data.error || "Connection interrupted. Please try again.",
        );
        error.httpStatus = response.status;
        error.details = data;
        throw error;
      }
      return data;
    };
    function mergeLibrary(items) {
      const merged = new Map(library.map(item => [item.id, item]));
      items.forEach(item => { if (item?.id && item?.style) merged.set(item.id, {...merged.get(item.id), ...item}); });
      library = [...merged.values()].sort((a, b) => (b.createdAt || "").localeCompare(a.createdAt || ""));
      save(); renderLibrary(); renderVersionHistory();
    }
    function toggleFavourite(id) {
      if (favourites.has(id)) favourites.delete(id); else favourites.add(id);
      save(); updateControls();
    }
    function renderLibrary() {
      if (isFunnel) $("[data-library]").hidden = phase !== "upload";
      $("[data-library-count]").textContent = String(library.length);
      $("[data-favourite-current]").setAttribute("aria-pressed", String(favourites.has(portraitId)));
      $("[data-favourite-current]").textContent = favourites.has(portraitId) ? "\u2665 Saved favourite" : "\u2661 Save favourite";
      if ($("[data-library]").hidden) return;
      const items = library.filter(item => libraryFilter !== "favourites" || favourites.has(item.id));
      const signature = JSON.stringify([items, [...favourites], portraitId, busy, Boolean(pending), visitor]);
      if (signature === librarySignature) return;
      librarySignature = signature;
      $("[data-library-grid]").replaceChildren(...items.map(item => {
        const card = document.createElement("article"); card.className = "pw-library-card";
        card.dataset.libraryId = item.id;
        const view = document.createElement("button"); view.type = "button"; view.className = "pw-library-preview";
        view.setAttribute("aria-label", (isFunnel ? "Choose print for " : "View ") + styleName(item.style));
        view.setAttribute("aria-pressed", String(item.id === portraitId && completed));
        view.disabled = busy || Boolean(pending); view.onclick = () => chooseVersion(item.id, isFunnel);
        const image = document.createElement("img"); image.src = url("preview", {id: item.id, thumbnail: "1"});
        image.alt = styleName(item.style); image.width = 160; image.height = 200; image.loading = "lazy";
        image.onerror = () => { image.hidden = true; };
        const label = document.createElement("strong"); label.textContent = styleName(item.style);
        const detail = document.createElement("small"); detail.textContent = item.artworkLabel || (item.createdAt ? new Date(item.createdAt).toLocaleDateString(undefined, {month:"short",day:"numeric",hour:"numeric",minute:"2-digit"}) : "Your saved portrait");
        view.append(image, label, detail);
        const heart = document.createElement("button"); heart.type = "button"; heart.className = "pw-library-heart";
        heart.setAttribute("aria-label", (favourites.has(item.id) ? "Unsave " : "Save ") + styleName(item.style));
        heart.setAttribute("aria-pressed", String(favourites.has(item.id))); heart.textContent = favourites.has(item.id) ? "\u2665" : "\u2661";
        heart.onclick = () => toggleFavourite(item.id);
        const order = document.createElement("button"); order.type = "button"; order.className = "pw-library-order";
        order.textContent = "Choose print"; order.disabled = busy || Boolean(pending);
        order.onclick = () => chooseVersion(item.id, true);
        card.append(view, heart, order); return card;
      }));
      if (!libraryLoading) $("[data-library-status]").textContent = items.length ? "" : libraryFilter === "favourites" ? "Tap a heart to keep your favourites here." : "Your finished portraits will appear here. Let's create your first.";
    }
    async function loadLibrary(more = false) {
      if (libraryLoading) return;
      let failure = "";
      libraryLoading = true; $("[data-library-status]").textContent = "Loading your portraits...";
      $("[data-library-more]").disabled = true;
      try {
        await ensureSession();
        const result = await api("portraits", undefined, more && libraryNext ? {before: libraryNext} : {});
        libraryNext = result.next || null; mergeLibrary(result.portraits || []);
        $("[data-library-status]").textContent = "";
      } catch { failure = "Couldn't load all your portraits. Your saved previews are still here. Tap refresh to retry."; }
      finally {
        libraryLoading = false; librarySignature = ""; updateControls();
        if (failure) $("[data-library-status]").textContent = failure;
        $("[data-library-more]").hidden = !libraryNext; $("[data-library-more]").disabled = false;
      }
    }
    function closeLibrary() { $("[data-library]").hidden = true; $("[data-open-library]").setAttribute("aria-expanded", "false"); }
    function openLibrary() {
      if (isFunnel) { if (busy || pending) return; setPhase("upload"); }
      $("[data-library]").hidden = false; $("[data-open-library]").setAttribute("aria-expanded", "true");
      librarySignature = ""; renderLibrary(); focusWork("[data-library]"); void loadLibrary();
    }
    $("[data-open-library]").onclick = () => $("[data-library]").hidden ? openLibrary() : closeLibrary();
    $("[data-close-library]").onclick = () => {closeLibrary(); $("[data-open-library]").focus({preventScroll:true});};
    $("[data-shop-library]").onclick = openLibrary;
    $("[data-refresh-library]").onclick = () => loadLibrary();
    $("[data-library-more]").onclick = () => loadLibrary(true);
    root.querySelectorAll("[data-library-filter]").forEach(button => {
      button.onclick = () => { libraryFilter = button.dataset.libraryFilter;
        root.querySelectorAll("[data-library-filter]").forEach(node => node.setAttribute("aria-pressed", String(node === button))); renderLibrary(); };
    });
    $("[data-favourite-current]").onclick = () => { if (completed) toggleFavourite(portraitId); };
    function rememberVersion(result, id) {
      if (Array.isArray(result.versions)) versions = result.versions;
      const item = {id, createdAt: result.createdAt || "", artworkLabel: result.artworkLabel || "",
        customization: result.customization || {background: "original"}, expectedSubjectCount: result.expectedSubjectCount ?? null,
        ...(Number.isInteger(result.sourcePhotoCount) ? {photos: result.sourcePhotoCount} : {})};
      const index = versions.findIndex(version => version.id === id);
      if (index < 0) versions.push(item);
      else versions[index] = {...versions[index], ...item};
      mergeLibrary(versions.map(version => ({...version, style: result.style || style})));
      historyUnavailable = Boolean(result.historyUnavailable);
      save();
    }
    const recentPortraits = () => {
      const items = new Map(library.map(item => [item.id, item]));
      versions.forEach(item => items.set(item.id, {...items.get(item.id), ...item, style: items.get(item.id)?.style || style}));
      return [...items.values()].sort((a,b) => (a.createdAt || "").localeCompare(b.createdAt || "")).slice(-64);
    };
    const versionLabel = id => {
      const items = recentPortraits(), index = items.findIndex(item => item.id === id);
      return "Version " + (index + 1) + " · " + styleName(items[index]?.style || style);
    };
    function renderVersionHistory() {
      const recent = recentPortraits();
      $("[data-version-history]").hidden = isFunnel ? recent.length < 2 : !recent.length;
      const signature = recent.map(item => item.id + item.style).join("|");
      if (signature !== historySignature) {
        historySignature = signature;
        $("[data-version-list]").replaceChildren(...recent.map(item => {
          const button = document.createElement("button");
          button.type = "button"; button.className = "pw-version-thumb";
          button.dataset.versionId = item.id;
          const image = document.createElement("img");
          image.src = url("preview", {id: item.id, thumbnail: "1"});
          image.width = 80; image.height = 100; image.loading = "lazy"; image.decoding = "async";
          image.alt = versionLabel(item.id) + " preview";
          image.onerror = () => { image.hidden = true; button.title = "Thumbnail unavailable. Select to load this version."; };
          const label = document.createElement("span"); label.textContent = versionLabel(item.id);
          const state = document.createElement("small"); state.dataset.versionState = "";
          button.append(image, label, state);
          button.onclick = () => chooseVersion(item.id);
          return button;
        }));
      }
      root.querySelectorAll("button[data-version-id]").forEach(button => {
        const active = button.dataset.versionId === (versionTargetId || portraitId) && (completed || versionLoading);
        button.setAttribute("aria-pressed", String(active));
        button.setAttribute("aria-label", versionLabel(button.dataset.versionId) + (active ? ", selected" : ", view this portrait"));
        button.querySelector("[data-version-state]").textContent = active ? "Selected" : button.dataset.versionId === recent[recent.length - 1]?.id ? "Latest" : "View";
        button.disabled = (busy && !versionLoading) || Boolean(pending) || (active && !versionLoading);
      });
      $("[data-compare-versions]").disabled = busy || Boolean(pending) || recent.length < 2;
      $("[data-history-error]").hidden = !historyUnavailable;
      $("[data-reload-history]").disabled = busy || Boolean(pending);
    }
    // Swipe between finished portraits. Neighbours peek at the edges and cached images switch without a loader.
    const textureKey = (id, v) => [id, v?.size || "original", v?.productType || "", v?.productType === "framed"].join(":");
    const textureReady = (id, v) => imageCache.get(textureKey(id, v))?.url;
    function savedPreview(id) {
      const cached = imageCache.get(textureKey(id));
      const thumb = [...root.querySelectorAll('[data-library-id], [data-version-id]')]
        .find(node => (node.dataset.libraryId || node.dataset.versionId) === id)?.querySelector('img');
      const ready = thumb?.complete && thumb.naturalWidth > 0;
      const remembered = library.find(item => item.id === id)?.previewRatio;
      return {
        source: cached?.url || (ready ? thumb.currentSrc || thumb.src : url("preview", {id, thumbnail:"1"})),
        ratio: cached?.ratio || (ready ? thumb.naturalWidth + "/" + thumb.naturalHeight : /^\d+\/\d+$/.test(remembered || "") ? remembered : "4/5"),
      };
    }
    let versionLoading = false, versionTargetId = "", queuedVersion = null, versionEpoch = 0, versionTask = null, cartIntent = false;
    const pairKey = "pawnted-print-pair-v2";
    let printPair = null;
    try { const saved=JSON.parse(sessionStorage.getItem(pairKey)||"null");if(saved?.at>Date.now()-86400000 && saved.first)printPair=saved; } catch {}
    let restorePairSelection=Boolean(printPair);
    const pairCard=document.createElement("section");pairCard.className="pw-pair-card";
    pairCard.setAttribute("aria-label","Build your pair of prints");
    pairCard.innerHTML='<div class="pw-pair-heading"><span>LIMITED TIME OFFER</span><button type="button" data-pair-reset hidden>Start over</button></div><h3 data-pair-price></h3><p data-pair-finish></p><div class="pw-pair-slots"><div class="pw-pair-slot"><img data-pair-first alt="First print" width="100" height="125"><span>Print 1</span></div><button class="pw-pair-slot pw-pair-choose" type="button" data-pair-choose><img data-pair-second alt="Second print" width="100" height="125" hidden><span data-pair-plus aria-hidden="true">+</span><span data-pair-label>Choose your second print</span></button></div><p class="pw-pair-hint" data-pair-hint>Same size and finish. Same or different artworks.</p>';
    $("[data-cart]").before(pairCard);
    pairCard.after($("[data-frame-label]"));
    const pairDialog=document.createElement("dialog");pairDialog.className="pw-pair-dialog";pairDialog.setAttribute("aria-labelledby","pw-pair-title");
    pairDialog.innerHTML='<header><div><span class="pw-pair-eyebrow">SAVE ON YOUR SECOND PRINT</span><h2 id="pw-pair-title">Make it a pair.</h2></div><button type="button" data-pair-close aria-label="Close second print chooser">&times;</button></header><p class="pw-pair-intro">Pick the artwork for your second print. We match the size and finish for you.</p><div class="pw-pair-options"><button type="button" data-pair-same><span class="pw-pair-option-icon" aria-hidden="true">&#10063;</span><span><strong>Use this artwork twice</strong><small>One to keep. One to give.</small></span><span class="pw-pair-arrow" aria-hidden="true">&rarr;</span></button><button type="button" data-pair-create><span class="pw-pair-option-icon" aria-hidden="true">+</span><span><strong>Create another artwork</strong><small>A different portrait, just as personal.</small></span><span class="pw-pair-arrow" aria-hidden="true">&rarr;</span></button></div><h3 data-pair-saved-heading>Or choose a saved artwork</h3><div class="pw-pair-saved" data-pair-saved></div>';
    root.append(pairDialog);
    function savePair() { try { if(printPair){printPair.at=Date.now();sessionStorage.setItem(pairKey,JSON.stringify(printPair));}else sessionStorage.removeItem(pairKey); }catch{} }
    function pairVariant() { return printPair?.fromCart ? variants.find(v=>String(v.id)===String(printPair.variantId)) : selected(); }
    function pairCounts() {
      const counts=new Map();for(const id of [printPair?.first,printPair?.second].filter(Boolean))counts.set(id,(counts.get(id)||0)+1);return counts;
    }
    function pairInBag(bag,v) { return (printPair?.targets ? Object.entries(printPair.targets) : [...pairCounts()]).every(([id,n])=>(bag.items||[]).filter(line=>line.properties?._pawnted_portrait_id===id && String(line.properties?._pawnted_base_variant||line.variant_id)===String(v?.id)).reduce((sum,line)=>sum+line.quantity,0)>=n); }
    function resetPair() { printPair=null;savePair();renderPair(); }
    function renderPair() {
      const v=pairVariant();pairCard.hidden=!isFunnel || !["product","cart"].includes(phase) || !completed || !v || !v.pairPrice;
      if(pairCard.hidden)return;
      if(restorePairSelection){restorePairSelection=false;const match=variants.find(item=>String(item.id)===String(printPair?.variantId));if(match&&String(selected()?.id)!==String(match.id)){$("[data-product]").value=match.productType;sizes(match.size,match.frameColor);return;}}
      if(printPair && !printPair.fromCart && String(printPair.variantId)!==String(v.id) && !printPair.awaitingNew){printPair.variantId=v.id;printPair.done=false;delete printPair.targets;savePair();}
      if(printPair?.fromCart && String(selected()?.id)!==String(v.id)){$("[data-product]").value=v.productType;sizes(v.size,v.frameColor);return;}
      if(printPair?.awaitingNew && portraitId && portraitId!==printPair.first && !busy && !versionLoading) {
        printPair.second=portraitId;printPair.awaitingNew=false;savePair();
        const match=variants.find(item=>String(item.id)===String(printPair.variantId));
        if(match){$("[data-product]").value=match.productType;sizes(match.size,match.frameColor);return;}
      }
      const first=printPair?.first || versionTargetId || portraitId, second=printPair?.second;
      const setImage=(el,id)=>{const source=savedPreview(id).source;if(el.getAttribute("src")!==source)el.src=source;};
      setImage($("[data-pair-first]"),first);$("[data-pair-second]").hidden=!second;$("[data-pair-plus]").hidden=Boolean(second);
      if(second)setImage($("[data-pair-second]"),second);
      $("[data-pair-price]").textContent="1 print · "+money(v.price)+" or 2 for "+money(v.pairPrice);
      $("[data-pair-finish]").textContent=v.size.replace("x"," × ")+" in · "+(v.frameColor ? v.frameColor+" framed canvas" : v.productType==="canvas"?"Canvas":"Print")+" · Free shipping";
      $("[data-pair-label]").textContent=second?"Second print selected":"Choose your second print";
      $("[data-pair-hint]").textContent=printPair?.done?"Your pair is in your bag. Your pair saving is included.":printPair?.fromCart?"Your first print is in your bag. Complete its pair here.":"Add a second print for "+money((Number(v.pairPrice)-Number(v.price)).toFixed(2))+". Same size and finish; any artwork.";
      $("[data-pair-reset]").hidden=!printPair;$("[data-pair-choose]").disabled=busy||cartIntent||versionLoading;$("[data-pair-reset]").disabled=busy||cartIntent;
      const pairAction=second ? (printPair.done ? "View your pair in the bag" : "Add both prints \u00b7 "+money(v.pairPrice)) : addedKey===cartKey() ? "View my bag \u2192" : "Add one print \u00b7 "+money(v.price);
      $("[data-cart]").textContent=pairAction;
      if(phase==="product")$("[data-mobile-action]").textContent=pairAction;
    }
    function openPairChooser() {
      if(busy||cartIntent||versionLoading)return;
      if(!printPair){const v=selected();if(!portraitId||!v)return;printPair={first:portraitId,variantId:v.id};savePair();}
      const holder=$("[data-pair-saved]");holder.replaceChildren();
      for(const item of library) {
        if(!item.id)continue;
        const button=document.createElement("button");button.type="button";button.dataset.pairSavedId=item.id;
        const img=document.createElement("img");img.src=savedPreview(item.id).source;img.alt=styleName(item.style);img.width=100;img.height=125;img.loading="lazy";
        const label=document.createElement("span");label.textContent=styleName(item.style);button.append(img,label);
        button.onclick=()=>selectPairArtwork(item.id);holder.append(button);
      }
      $("[data-pair-saved-heading]").hidden=!holder.children.length;
      if(!pairDialog.open)pairDialog.showModal();
    }
    function selectPairArtwork(id) { printPair.second=id;printPair.done=false;printPair.awaitingNew=false;delete printPair.targets;savePair();pairDialog.close();renderPair(); }
    function createPairArtwork() { if(!printPair)return;printPair.awaitingNew=true;printPair.second=null;printPair.done=false;delete printPair.targets;savePair();pairDialog.close();window.PawntedFunnel?.showStyles(); }
    $("[data-pair-choose]").onclick=openPairChooser;$("[data-pair-close]").onclick=()=>pairDialog.close();
    $("[data-pair-reset]").onclick=resetPair;$("[data-pair-same]").onclick=()=>selectPairArtwork(printPair.first);$("[data-pair-create]").onclick=createPairArtwork;
    async function startCartPair(line,action="create") {
      if(busy||cartIntent||pending)return false;
      await ensureCatalog();const v=variants.find(v=>String(v.id)===String(line.properties?._pawnted_base_variant||line.variant_id));if(!v)return false;
      printPair={first:line.properties._pawnted_portrait_id,variantId:v.id,fromCart:true};savePair();
      if(action==="same"){printPair.second=printPair.first;savePair();await addPairToCart();}
      else if(action==="saved"){await chooseVersion(printPair.first,true);openPairChooser();}
      else createPairArtwork();
      return true;
    }
    async function addPairToCart() {
      const v=pairVariant();if(!v||!printPair?.second||cartIntent||busy)return;
      if(printPair.done){await window.PawntedCart?.open({trigger:$("[data-cart]")});return;}
      const wanted=pairCounts(), ids=[...wanted.keys()];cartIntent=true;const controls=$(".pw-pdp-grid");if(controls)controls.inert=true;updateControls();
      const price=Math.round(Number(v.price)*100), cartRoot=window.Shopify?.routes?.root||"/";
      const pendingItems=ids.map(id=>({key:"pending:"+id+":"+v.id,variant_id:v.id,sku:v.sku,quantity:wanted.get(id),product_title:styleName(library.find(p=>p.id===id)?.style||style),variant_title:v.size.replace("x"," × ")+" in · "+(v.frameColor||v.productType),price,original_line_price:price*wanted.get(id),final_line_price:price*wanted.get(id),requires_shipping:true,properties:{_pawnted_portrait_id:id,_pawnted_base_variant:v.id,_pawnted_preview:savedPreview(id).source,"Free gift":"Digital print"}}));
      void window.PawntedCart?.open({trigger:$("[data-cart]"),pending:true,items:pendingItems});
      try {
        const [prepared,bag]=await Promise.all([Promise.all(ids.map(id=>preparedCartItem(id,v))),fetchBounded(cartRoot+"cart.js").then(async response=>{if(!response.ok)throw Error("Couldn't check your bag. Please try again.");const bag=await response.json();window.PawntedCart?.hydrateAdd?.(bag);return bag;})]);
        const matching=bag.items.filter(line=>String(line.properties?._pawnted_base_variant||line.variant_id)===String(v.id));
        const existingCount=id=>matching.filter(line=>line.properties?._pawnted_portrait_id===id).reduce((n,line)=>n+line.quantity,0);
        if(!printPair.targets){const useFirst=matching.reduce((n,line)=>n+line.quantity,0)%2===1 && existingCount(printPair.first)>0;printPair.targets=Object.fromEntries(ids.map(id=>[id,existingCount(id)+wanted.get(id)-(useFirst&&id===printPair.first?1:0)]));savePair();}
        // Persist exact target quantities before the POST: a lost response can be retried without adding another pair.
        void window.PawntedCart?.open({pending:true,items:pendingItems.map(item=>({...item,quantity:printPair.targets[item.properties._pawnted_portrait_id]}))});
        window.PawntedCart?.hydrateAdd?.(bag);
        const items=prepared.flatMap((item,index)=>{const id=ids[index],quantity=Math.max(0,printPair.targets[id]-existingCount(id));return quantity?[{...item,quantity}]:[];});
        if(items.length){const response=await fetchBounded(cartRoot+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items})});if(!response.ok){const problem=await response.json().catch(()=>({}));throw Error(problem.description||"Could not add your pair. Please try again.");}}
        for(const id of ids)recordCartArtwork(id,v.id,items.some(item=>item.properties?._pawnted_portrait_id===id)?"cart_added":"cart_observed");
        printPair.done=true;savePair();addedKey="";
        await window.PawntedCart?.finishAdd("Your pair is in the bag. Your pair saving is included.");
      }catch(error){status(error.message);await window.PawntedCart?.finishAdd(error.message,false);}
      finally{cartIntent=false;if(controls)controls.inert=false;updateControls();}
    }
    let swiper = null, swiperSignature = "", slider = null;
    // Native scrolling owns the gesture and momentum. Selection changes only
    // after scrolling settles; async artwork updates never reposition a drag.
    function createPortraitSlider(element) {
      let selectedId = "", pointerDown = false, touchDown = false, moving = false, userScroll = false;
      let settleTimer = 0, dragged = false, startX = 0, startY = 0, startLeft = 0;
      const slides = () => [...element.children];
      const interacting = () => pointerDown || touchDown || moving;
      const lockBuying = () => { $("[data-cart]").disabled = true; $("[data-mobile-action]").disabled = true; };
      const nearest = () => {
        const bounds = element.getBoundingClientRect(), centre = bounds.left + bounds.width / 2;
        return slides().reduce((best, slide) => {
          const rect = slide.getBoundingClientRect(), distance = Math.abs(rect.left + rect.width / 2 - centre);
          return !best || distance < best.distance ? {slide, distance} : best;
        }, null)?.slide;
      };
      const centreOn = (slide, smooth = false) => {
        if (!slide || !element.clientWidth) return;
        const bounds = element.getBoundingClientRect(), rect = slide.getBoundingClientRect();
        const left = Math.max(0, Math.min(element.scrollWidth - element.clientWidth,
          element.scrollLeft + rect.left + rect.width / 2 - bounds.left - bounds.width / 2));
        element.scrollTo({left, behavior:smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'});
      };
      const settle = () => {
        clearTimeout(settleTimer); settleTimer = 0;
        if (pointerDown || touchDown) return;
        moving = false;
        const id = nearest()?.dataset.swipeId;
        const commit = userScroll; userScroll = false;
        if (commit && id && !cartIntent && ["preview", "product"].includes(phase)) {
          selectedId = id;
          if (id !== (versionTargetId || portraitId) && !(busy && !versionLoading) && !pending) {
            track('version_swiped', {});
            void chooseVersion(id, false, true);
          }
        }
        updateControls();
      };
      const scheduleSettle = () => {
        clearTimeout(settleTimer);
        // Fallback for browsers without scrollend; each momentum frame resets it.
        settleTimer = setTimeout(settle, 180);
      };
      element.addEventListener('pointerdown', event => {
        pointerDown = true; userScroll = true; dragged = false; lockBuying();
        startX = event.clientX; startY = event.clientY; startLeft = element.scrollLeft;
        clearTimeout(settleTimer);
      }, {passive:true});
      element.addEventListener('pointermove', event => {
        if (pointerDown && Math.hypot(event.clientX-startX,event.clientY-startY)>8) dragged = true;
      }, {passive:true});
      const release = () => {
        if (!pointerDown) return;
        pointerDown = false;
        if (Math.abs(element.scrollLeft-startLeft)>4) dragged = true;
        scheduleSettle();
      };
      element.addEventListener('touchstart', () => {touchDown=true;}, {passive:true});
      const releaseTouch = () => {touchDown=false;release();scheduleSettle();};
      element.addEventListener('touchend', releaseTouch, {passive:true});
      element.addEventListener('touchcancel', releaseTouch, {passive:true});
      window.addEventListener('pointerup', release, {passive:true});
      window.addEventListener('pointercancel', release, {passive:true});
      element.addEventListener('wheel', () => {userScroll=true;lockBuying();scheduleSettle();}, {passive:true});
      element.addEventListener('scroll', () => {
        moving = true;
        if (pointerDown && Math.abs(element.scrollLeft-startLeft)>4) dragged = true;
        scheduleSettle();
      }, {passive:true});
      element.addEventListener('scrollend', settle, {passive:true});
      element.addEventListener('click', event => {
        const slide = event.target.closest('[data-swipe-id]');
        if (!slide || !element.contains(slide)) return;
        if (dragged && event.detail !== 0) {event.preventDefault();dragged=false;return;}
        if (slide.dataset.swipeId === portraitId && !versionLoading) {
          userScroll=false;$("[data-expand]").click();return;
        }
        userScroll=true;moving=true;lockBuying();centreOn(slide,true);scheduleSettle();
      });
      element.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const items=slides(), index=items.indexOf(nearest());
        const next=event.key==='Home'?0:event.key==='End'?items.length-1:Math.max(0,Math.min(items.length-1,index+(event.key==='ArrowRight'?1:-1)));
        items[next]?.focus({preventScroll:true});userScroll=true;moving=true;lockBuying();centreOn(items[next],true);scheduleSettle();
      });
      new ResizeObserver(() => {
        if (!interacting()) centreOn(slides().find(slide=>slide.dataset.swipeId===selectedId));
      }).observe(element);
      return {
        interacting,
        select(id) {
          clearTimeout(settleTimer);settleTimer=0;userScroll=false;moving=false;selectedId=id;
          centreOn(slides().find(slide=>slide.dataset.swipeId===id));
        },
        sync(id, reset = false) {
          if (interacting() || (selectedId===id && !reset)) return;
          selectedId=id;userScroll=false;
          centreOn(slides().find(slide=>slide.dataset.swipeId===id));
        },
      };
    }
    function renderSwiper() {
      if (!isFunnel) return;
      const recent = recentPortraits().slice(-8);
      const displayId = versionTargetId || portraitId;
      const active = (completed || versionLoading) && ["preview", "product"].includes(phase) && recent.length > 1 && recent.some(item => item.id === displayId);
      root.dataset.swiper = String(active);
      if (!active) return;
      if (!swiper) {
        swiper = document.createElement("div");
        swiper.className = "pw-version-swiper"; swiper.dataset.versionSwiper = "";
        swiper.setAttribute("role", "group"); swiper.setAttribute("aria-label", "Your portraits. Swipe to compare.");
        const count = document.createElement("p"); count.className = "pw-swipe-count"; count.dataset.swipeCount = "";
        $(".pw-artwork-view").after(swiper); $("[data-visual]").after(count);
        slider = createPortraitSlider(swiper);
      }
      const signature = recent.map(item => item.id).join("|");
      const rebuilt = signature !== swiperSignature;
      if (rebuilt && slider.interacting()) return;
      if (rebuilt) {
        swiperSignature = signature;
        swiper.replaceChildren(...recent.map(item => {
          const slide = document.createElement("button");
          slide.type = "button"; slide.className = "pw-version-slide"; slide.dataset.swipeId = item.id;
          const image = document.createElement("img");
          const preview = savedPreview(item.id), dimensions = preview.ratio.split("/").map(Number);
          image.alt = versionLabel(item.id); image.draggable = false; image.decoding = "async";
          image.width = dimensions[0]; image.height = dimensions[1];
          // Keep thumbnail and full-resolution decoding in the same reserved box.
          image.style.aspectRatio = preview.ratio; image.style.objectFit = "contain";
          image.src = preview.source;
          if (!textureReady(item.id)) getTexture(item.id).then(source => { image.src = source; }).catch(() => {});
          slide.append(image);

          return slide;
        }));
      }
      const index = recent.findIndex(item => item.id === displayId);
      swiper.querySelectorAll("[data-swipe-id]").forEach(slide => {
        const current = slide.dataset.swipeId === displayId;
        slide.setAttribute("aria-current", String(current));
        slide.setAttribute("aria-label", versionLabel(slide.dataset.swipeId) + (current ? ", selected. Open full screen" : ". Show this portrait"));
      });
      $("[data-swipe-count]").textContent = styleName(recent[index]?.style || style) + " · " + (index + 1) + " of " + recent.length + " · Swipe to compare";
      slider.sync(displayId, rebuilt);
    }
    // Reloading on a finished portrait: show it straight away (thumbnail first, then the full image)
    // instead of the "creating" loader. Falls back to normal polling if it is not finished after all.
    let quietResume = false;
    async function resumeFinished() {
      const id = portraitId, epoch = versionEpoch;
      quietResume = true; portraitId = "";
      root.dataset.generated = "true"; $(".pw-preview").src = url("preview", {id, thumbnail: "1"});
      try { await chooseVersion(id, false, true); }
      finally { quietResume = false; }
      if (epoch !== versionEpoch) return;
      if (portraitId !== id || !completed) { portraitId = id; return poll(); }
    }
    function chooseVersion(id, order = false, quiet = false) {
      const startsLoad = !versionLoading;
      const task = loadVersion(id, order, quiet);
      if (startsLoad) versionTask = task;
      return task;
    }
    async function loadVersion(id, order = false, quiet = false) {
      const entry = library.find(item => item.id === id) || versions.find(item => item.id === id);
      if (!entry || pending) return;
      if (!quiet) slider?.select(id);
      if (versionLoading) {
        if (id === versionTargetId) return;
        queuedVersion = {id, order, quiet}; versionTargetId = id; previewRevision++;
        renderVersionHistory(); renderSwiper(); return;
      }
      if (busy) return;
      if (id === portraitId && completed && !isFunnel) {
        closeLibrary();
        if (order) return $("[data-approve]").onclick();
        return reviewPortrait();
      }
      const epoch = versionEpoch;
      const fromUpload = phase === "upload", wasApproved = approved;
      const destination = isFunnel ? "product" : "preview";
      versionLoading = true; versionTargetId = id;
      busy = true; approved = false; previewReady = false; previewRevision++;
      const instant = textureReady(id);
      if (isFunnel) {
        const preview = savedPreview(id);
        root.dataset.generated = "true";
        showOriginalArtwork(preview.source, preview.ratio);
      }
      progressValue = 0; showProgress(97); if (instant && !isFunnel) showOriginalArtwork(instant);
      setPhase(destination); void switchView("artwork"); if (isFunnel) { loading(false); } else if (!instant && !quietResume) loading(true, "Loading your chosen portrait.");
      if (isFunnel && fromUpload && !quiet) focusWork(".pw-pdp-grid", true);
      let loaded = false;
      try {
        await ensureSession();
        const result = await api("restore", undefined, {id});
        if (epoch !== versionEpoch || queuedVersion) return;
        if (result.status !== "completed") throw new Error("This portrait is not available yet.");
        portraitId = id; previousPortraitId = ""; completed = true;
        style = result.style || entry.style || style;
        versions = [];
        // Reusing this portrait must use its own subjects, even after another upload.
        reuseSourceId = id; photoRevision++; files = []; uploadedPaths = null; uploadPromise = null;
        thumbUrls.forEach(source => URL.revokeObjectURL(source)); thumbUrls = []; $(".pw-photos").replaceChildren();
        $("[data-photo-summary]").textContent = "Your saved photos are ready";
        if (printSelections[id] && variants.length) {
          selection = printSelections[id]; $("[data-product]").value = selection.productType;
          sizes(selection.size, selection.frameColor);
        }
        restorePaintedOptions(result); rememberVersion(result, id); showStyle(); syncAddress();
        $(".pw-change").hidden = true; closeLibrary(); loaded = true;
        status(isFunnel ? "" : styleName(style) + " selected. Choose your print whenever you're ready.");
      } catch (error) { if (epoch === versionEpoch && !queuedVersion) { status(error.message); } }
      finally {
        if (epoch !== versionEpoch) return;
        busy = false;
        if (!queuedVersion) {
          approved = isFunnel && loaded ? true : wasApproved; setPhase(destination);
          await refreshPreview();
        }
        if (epoch !== versionEpoch) return;
        versionLoading = false;
        if (queuedVersion) {
          const next = queuedVersion; queuedVersion = null;
          await chooseVersion(next.id, next.order, next.quiet);
        } else {
          versionTargetId = ""; updateControls(); save();
          if (!quiet && !isFunnel) focusWork();
          if (isFunnel && loaded) track("print_options_viewed", {}, portraitId);
          if (isFunnel && fromUpload && !quiet) focusWork(".pw-pdp-grid", true);
        }
      }
      if (!isFunnel && loaded && order && previewReady && portraitId === id) await $("[data-approve]").onclick();
    }
    $("[data-reload-history]").onclick = async () => {
      if (busy || pending || !completed) return;
      try { rememberVersion(await api("restore", undefined, {id: portraitId}), portraitId); }
      catch { historyUnavailable = true; }
      renderVersionHistory();
    };
    const compareDialog = $("[data-version-compare]");
    const comparisonRevision = {left: 0, right: 0};
    async function updateComparison(side) {
      const revision = ++comparisonRevision[side];
      const id = $(`[data-compare-select="${side}"]`).value;
      const item = recentPortraits().find(version => version.id === id);
      if (!item) return;
      const image = $(`[data-compare-image="${side}"]`);
      const message = $(`[data-compare-status="${side}"]`);
      image.style.visibility = "hidden";
      image.alt = versionLabel(id) + " portrait";
      message.textContent = "Loading " + versionLabel(id).toLowerCase() + "..."; message.hidden = false;
      const colour = backgroundRadios.find(radio => radio.value === item.customization?.background)?.getAttribute("aria-label") || "Original palette";
      $(`[data-compare-details="${side}"]`).textContent = [styleName(item.style), colour, item.expectedSubjectCount ? item.expectedSubjectCount + (item.expectedSubjectCount === 1 ? " subject" : " subjects") : "", item.artworkLabel].filter(Boolean).join(" \u00b7 ");
      const button = $(`[data-use-version="${side}"]`);
      button.disabled = true; button.textContent = id === portraitId ? "Selected version" : "Use " + versionLabel(id).toLowerCase();
      try {
        const source = await getTexture(id);
        if (revision !== comparisonRevision[side]) return;
        image.src = source; image.dataset.comparedVersionId = id; image.style.visibility = "visible";
        message.textContent = ""; message.hidden = true;
        button.disabled = id === portraitId;
      } catch {
        if (revision !== comparisonRevision[side]) return;
        message.textContent = "Preview unavailable. Close this comparison and select its thumbnail to try again.";
      }
    }
    function closeComparison() {
      comparisonRevision.left++; comparisonRevision.right++;
      if (compareDialog.close) compareDialog.close(); else compareDialog.removeAttribute("open");
      document.documentElement.classList.remove("pw-art-open");
      $("[data-compare-versions]").focus({preventScroll: true});
    }
    $("[data-compare-versions]").onclick = () => {
      const recent = recentPortraits();
      if (busy || pending || recent.length < 2) return;
      const current = recent.find(item => item.id === portraitId) || recent[recent.length - 1];
      const entries = recent.map(item => [item.id, versionLabel(item.id)]);
      const previous = [...recent].reverse().find(item => item.id !== current.id);
      options($('[data-compare-select="left"]'), entries, previous.id);
      options($('[data-compare-select="right"]'), entries, current.id);
      track("comparison_opened", {crossStyle: previous.style !== current.style});
      updateComparison("left"); updateComparison("right");
      if (compareDialog.showModal) compareDialog.showModal(); else compareDialog.setAttribute("open", "");
      document.documentElement.classList.add("pw-art-open");
      $("[data-close-compare]").focus({preventScroll: true});
    };
    $("[data-close-compare]").onclick = closeComparison;
    compareDialog.addEventListener("cancel", event => { event.preventDefault(); closeComparison(); });
    compareDialog.addEventListener("click", event => { if (event.target === compareDialog) closeComparison(); });
    compareDialog.addEventListener("keydown", event => {
      if (event.key === "Escape") {event.preventDefault(); closeComparison();}
      if (event.key !== "Tab") return;
      const controls = [...compareDialog.querySelectorAll("button, select")].filter(node => !node.disabled);
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {event.preventDefault(); last.focus();}
      else if (!event.shiftKey && document.activeElement === last) {event.preventDefault(); first.focus();}
    });
    for (const side of ["left", "right"]) {
      $(`[data-compare-select="${side}"]`).onchange = () => updateComparison(side);
      $(`[data-use-version="${side}"]`).onclick = () => {
        if ($(`[data-use-version="${side}"]`).disabled) return;
        const id = $(`[data-compare-select="${side}"]`).value;
        closeComparison(); return chooseVersion(id);
      };
    }
    function renderSavedPhotos() {
      if (!isFunnel) return;
      const reusing = Boolean(reuseSourceId) && !files.length;
      root.dataset.savedPhotos = String(reusing);
      let saved = $("[data-saved-photos]");
      if (!saved) {
        // Its own row, so clearing the visitor's newly chosen photos never clears these.
        saved = document.createElement("div"); saved.className = "pw-photos pw-saved-photos"; saved.dataset.savedPhotos = "";
        const note = document.createElement("p"); note.className = "pw-note pw-saved-photos-note"; note.dataset.savedPhotosNote = "";
        $(".pw-photos").after(saved, note);
      }
      const note = $("[data-saved-photos-note]");
      saved.hidden = note.hidden = !reusing;
      note.textContent = completed ? "The photos used for this portrait. Choose new photos above to make another." : "Saved from your last portrait. Create uses these, or choose new photos above.";
      $(".pw-upload strong").textContent = reusing ? "Choose new photos" : files.length ? (files.length < 4 ? "Add more photos" : "Choose different photos") : "Choose photos";
      if (!reusing) { savedPhotosFor = ""; savedPhotosKept = null; renderedSavedPhotosFor = ""; saved.replaceChildren(); return; }
      if (!visitor || renderedSavedPhotosFor === reuseSourceId) return;
      if (savedPhotosFor !== reuseSourceId) { savedPhotosFor = reuseSourceId; savedPhotosKept = null; }
      renderedSavedPhotosFor = reuseSourceId;
      // Older saved portraits do not record a photo count: ask for up to four and drop the ones that do not exist.
      const known = library.find(item => item.id === reuseSourceId)?.photos;
      const indices = savedPhotosKept || Array.from({length: Number.isInteger(known) ? known : 4}, (_, index) => index);
      saved.replaceChildren(...indices.map(index => {
        const item = document.createElement("div"); item.className = "pw-photo-item pw-photo-saved";
        const image = document.createElement("img");
        image.alt = "Saved photo " + (index + 1); image.width = 120; image.height = 120; image.decoding = "async";
        item.dataset.savedIndex = String(index);
        image.onerror = () => item.remove();
        image.src = url("preview", {id: reuseSourceId, source: String(index)});
        const remove = document.createElement("button");
        remove.type = "button"; remove.className = "pw-photo-remove"; remove.textContent = "Remove"; remove.setAttribute("aria-label", "Remove saved photo " + (index + 1));
        remove.onclick = () => {
          if (busy || pending) return;
          item.remove();
          const left = [...saved.querySelectorAll("[data-saved-index]")].map(node => Number(node.dataset.savedIndex));
          // Removing the last saved photo means starting again with new ones.
          if (!left.length) { reuseSourceId = ""; resetPortrait(); } else savedPhotosKept = left;
          updateControls();
          save();
        };
        item.append(image, remove); return item;
      }));
    }
    // "Email me my portrait": lets visitors leave and come back on any device.
    const emailedKey = "pawnted-emailed-v1";
    let emailed = {};
    try { emailed = JSON.parse(localStorage.getItem(emailedKey) || "{}") || {}; } catch {}
    let emailCard = null, emailBusy = false;
    function renderEmailCard() {
      const buy = $(".pw-buy");
      if (!emailCard && buy) {
        emailCard = document.createElement("section");
        emailCard.className = "pw-email-card";
        emailCard.setAttribute("aria-labelledby", "pw-email-title");
        emailCard.innerHTML = '<h2 id="pw-email-title">Not ready to order yet?</h2><p>We&rsquo;ll email your portrait so you can open it on any device, whenever you&rsquo;re ready.</p><form data-email-form novalidate><label class="pw-sr-only" for="pw-email-input">Email address</label><input id="pw-email-input" type="email" name="email" autocomplete="email" inputmode="email" maxlength="254" placeholder="you@example.com" required><button type="submit">Email me my portrait</button></form><p class="pw-email-status" data-email-status role="status" aria-live="polite"></p><p class="pw-email-fine">We may send a reminder or two. Unsubscribe any time.</p>';
        buy.after(emailCard);
        const form = emailCard.querySelector("[data-email-form]"), input = form.querySelector("input");
        if (emailed.email) input.value = emailed.email;
        form.addEventListener("submit", async event => {
          event.preventDefault();
          const statusLine = emailCard.querySelector("[data-email-status]"), id = portraitId, email = input.value.trim();
          if (emailBusy || !id) return;
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { statusLine.textContent = "Please enter a valid email address."; input.focus(); return; }
          emailBusy = true; form.querySelector("button").disabled = true; statusLine.textContent = "Sending your portrait...";
          try {
            await ensureSession();
            await api("portrait-email", {id, email});
            emailed = {email, ids: [...(emailed.ids || []).filter(item => item !== id), id].slice(-50)};
            try { localStorage.setItem(emailedKey, JSON.stringify(emailed)); } catch {}
            statusLine.textContent = "Sent! Check your inbox for your portrait.";
            track("email_captured", {}, id);
          } catch (error) { statusLine.textContent = error.message || "Please try again."; }
          finally { emailBusy = false; renderEmailCard(); }
        });
      }
      if (!emailCard) return;
      const sent = (emailed.ids || []).includes(portraitId);
      // Stay in place while switching portraits so the page doesn't jump.
      emailCard.hidden = !completed || !portraitId || !["preview", "product", "cart"].includes(phase);
      emailCard.querySelector("[data-email-form] button").disabled = emailBusy || busy || Boolean(pending);
      emailCard.dataset.sent = String(sent);
      emailCard.querySelector("h2").textContent = sent ? "Your portrait is in your inbox." : "Not ready to order yet?";
      emailCard.querySelector("[data-email-form]").hidden = sent;
      emailCard.querySelector(".pw-email-fine").hidden = sent;
      if (sent && !emailCard.querySelector("[data-email-status]").textContent) emailCard.querySelector("[data-email-status]").textContent = "Emailed to " + (emailed.email || "you") + ".";
      if (!sent && emailCard.querySelector("[data-email-status]").textContent.startsWith("Emailed to")) emailCard.querySelector("[data-email-status]").textContent = "";
    }
    function updateControls() {
      renderEmailCard();
      renderVersionHistory(); renderLibrary(); renderSwiper(); renderSavedPhotos();
      renderPrice();
      $("[data-new-portrait]").hidden = !completed || !["preview", "product", "cart"].includes(phase);
      $("[data-new-portrait-style]").textContent = styleName(style);
      root.querySelectorAll("[data-new-photos], [data-same-photos]").forEach(button => { button.disabled = busy || hashing || Boolean(pending) || !completed; });
      $("[data-reuse-photos]").hidden = !reuseSourceId || Boolean(files.length);
      $("[data-browse-styles]").disabled = busy || Boolean(pending) || hashing;
      $("[data-another-style]").disabled = busy || Boolean(pending);
      $("[data-keep-creating]").disabled = busy || Boolean(pending);
      $("[data-favourite-current]").disabled = !completed || busy;
      $("[data-added]").hidden = addedKey !== cartKey() || phase !== "product";
      $("[data-cart]").textContent = addedKey === (versionTargetId || portraitId) + ":" + (selected()?.id || "") ? "View my bag \u2192" : isFunnel ? "Add to cart" : "Add my portrait to bag \u2197";
      renderPair();
      const nameChanged = artworkChanged();
      const canBuy = isFunnel ? canRequestCart() :
        completed && approved && phase === "product" && previewReady && Boolean(selected()) && !busy && !versionLoading && !slider?.interacting() && !nameChanged;
      scheduleCartPreparation(canBuy && !versionLoading && previewReady);
      $("[data-paint]").disabled =
        busy || hashing || (!files.length && !pending && !portraitId && !reuseSourceId);
      $("[data-paint]").textContent =
        (pending || (portraitId && !completed)) && !busy
          ? "Reconnect to my portrait ↗"
          : busy
            ? "Creating your portrait…"
            : nameChanged ? "Create my updated portrait ↗" : completed
              ? "Create another portrait ↗"
              : "Create my portrait ↗";
      $("[data-files]").disabled = busy || hashing || Boolean(pending);
      root.querySelectorAll("[data-remove-photo]").forEach(button => { button.disabled = busy || hashing || Boolean(pending); });
      $("[data-name]").disabled = busy || Boolean(pending);
      backgroundSelect.disabled = busy || Boolean(pending);
      backgroundRadios.forEach(radio => { radio.disabled = busy || Boolean(pending); });
      $("[data-change-style]").disabled = busy || Boolean(pending) || hashing;
      $("[data-credit-topup]").disabled = busy || Boolean(pending);
      $(".pw-styles")
        .querySelectorAll("button")
        .forEach((button) => {
          button.disabled = busy || Boolean(pending);
        });
      $("[data-approve]").disabled = busy || !completed || !previewReady || nameChanged;
      $("[data-adjust]").disabled = busy || !completed;
      $("[data-retry]").disabled = busy || !completed;
      $(".pw-change button").disabled = busy || !completed;
      $("[data-cart]").disabled = !canBuy;
      $('[data-view="3d"]').hidden = phase !== "product";
      $('[data-view="3d"]').disabled = phase !== "product" || busy || !completed || !previewReady || !selected();
      $("[data-expand]").disabled =
        busy || !$(".pw-preview").src || (completed && !previewReady);
      $("[data-review]").hidden = !completed || phase !== "preview";
      $("[data-photo-panel]").hidden = phase !== "upload";
      $("[data-return-portrait]").hidden = !completed;
      $("[data-finish]").hidden = !["product", "cart"].includes(phase);
      $(".pw-buy").hidden = !["product", "cart"].includes(phase);
      $("[data-waiting-card]").hidden = phase !== "waiting";
      $(".pw-pdp-value").hidden = !["upload", "product", "cart"].includes(phase);
      $(".pw-pdp-details").hidden = phase !== "product";
      root.querySelectorAll("[data-step]").forEach(button => {
        const step = button.dataset.step;
        button.disabled = busy || Boolean(pending) || (step !== "upload" && !completed) || (step === "product" && !approved);
        if (step === (phase === "waiting" ? "preview" : phase === "cart" ? "product" : phase)) button.setAttribute("aria-current", "step");
        else button.removeAttribute("aria-current");
      });
      $("[data-approve]").textContent = "Choose size & frame";
      $("[data-review-copy]").textContent = approved
        ? "Good choice. Your size and finish are ready to make yours."
        : "Zoom in. Check the details. Make sure it feels like them.";
      $("[data-cart-help]").textContent = busy
        ? "Your portrait is on its way."
        : nameChanged ? "Create your updated choices before approving the portrait." : !completed
          ? "Your portrait comes first. Upload your photos above."
          : !previewReady
            ? "Loading your exact print layout…"
            : !approved
              ? "Love the preview? Approve it to unlock your bag."
              : "Your portrait. Your finish. Ready for your wall.";
      $("[data-mobile-action]").disabled =
        (busy && !(isFunnel && phase === "product" && canBuy)) || hashing || (phase === "product" && !canBuy) || (phase === "preview" && !previewReady);
      $("[data-mobile-action]").textContent = busy
        ? phase === "cart"
          ? "Adding…"
          : "Painting…"
        : nameChanged ? "Update my portrait ↗" : phase === "product"
          ? addedKey === cartKey() ? "View bag \u2192" : isFunnel ? "Add to cart" : "Add to bag \u2197"
          : completed && phase === "preview"
            ? "Choose my print ↗"
            : completed && phase === "upload" ? "Back to my portrait ↗"
            : pending || portraitId
              ? "Reconnect ↗"
              : files.length || reuseSourceId
                ? "Create my portrait ↗"
                : "Upload my photo ↗";
      $("[data-mobile-note]").textContent = phase === "waiting" ? "Creating your portrait" : phase === "preview" ? "Love it? Choose your print" : phase === "product" && selected()
        ? selected().size.replace("x", " × ") +
          " in · " +
          (selected().frameColor ||
            (selected().productType === "canvas" ? "Canvas" : "Print"))
        : "Preview before you pay";
      if (isFunnel) {
        const free = Number(creditBalance?.free || 0) > 0;
        const exhausted = creditBalance?.total === 0;
        if (phase === "upload") {
          $("[data-mobile-price]").textContent = free ? "Free preview" : "Preview first";
          $("[data-mobile-note]").textContent = exhausted ? "Free credits refill daily" : "Prints optional · from US$34.95";
          if (!busy && !pending && !completed && !portraitId) {
            $("[data-paint]").textContent = free ? "Create my free preview →" : "Create my preview · 1 credit";
            $("[data-mobile-action]").textContent = exhausted ? "View my credits →" : files.length || reuseSourceId ? free ? "Create my free preview →" : "Create my preview →" : "Choose my photo →";
          }
        }
        $("[data-approve]").textContent = "Make this my print →";
        if (phase === "preview") $("[data-mobile-action]").textContent = "Make this my print →";
        if (exhausted && !busy && !pending && !(portraitId && !completed)) {
          root.dataset.showCredits = "true";
          $("[data-paint]").disabled = true;
          $("[data-retry]").disabled = true;
          $("[data-same-photos]").disabled = true;
        }
        const nextState = [phase,busy,versionLoading,cartIntent,hashing,Boolean(pending),topupBusy,files.length,library.length,versions.length,completed,approved,previewReady,creditBalance?.free,creditBalance?.paid,style,portraitId].join(":");
        if (root.dataset.funnelState !== nextState) root.dataset.funnelState = nextState;
      }
      root.dataset.hasPhotos = String(Boolean(files.length || reuseSourceId));
      root.dataset.photosReady = String(Boolean(files.length || reuseSourceId) && !completed);
      $("[data-ready-summary]").hidden = root.dataset.photosReady !== "true" || phase !== "upload";
      $("[data-ready-summary-text]").textContent = library.length ? "Your photos are ready. Previous portraits stay saved." : "Your photos are ready.";
      root.querySelectorAll("[data-generation-cost]").forEach(node => {node.textContent = generationCost();});
      $("[data-retry]").textContent = "Make another version";
      $("[data-same-photos]").textContent = "Make another version";
      $("[data-same-photos]").hidden = phase === "preview";
      $("[data-approve]").textContent = "Choose print →";
      if (phase === "preview") $("[data-mobile-action]").textContent = "Choose print →";
      if (phase === "preview" && creditBalance) $("[data-mobile-note]").textContent = creditBalance.free > 0 ? `${creditBalance.free} free previews left` : creditBalance.paid > 0 ? `${creditBalance.paid} purchased previews left` : "View & compare for free";
      $("[data-mobile-style]").hidden = !completed || !["preview", "product"].includes(phase);
      $("[data-mobile-style]").disabled = busy || Boolean(pending);
      if (isFunnel) {
        $("[data-mobile-style]").hidden = true;
        $("[data-mobile-options]").hidden = true;
        $("[data-edit-pencil]").hidden = $("[data-art-retry]").hidden = !completed || busy || Boolean(pending) || !["preview", "product"].includes(phase);
        $("[data-art-retry]").disabled = creditBalance?.total === 0;
        root.querySelectorAll("[data-review-options], [data-create-another-style], [data-buy-options]").forEach(button => { button.disabled = busy || Boolean(pending) || !completed; });
      }
      $("[data-reveal-actions]").hidden = !completed || phase !== "preview";
      $("[data-reveal-style]").disabled = busy || Boolean(pending);
      $("[data-reveal-retry]").disabled = busy || !completed || creditBalance?.total === 0;
      if (!isFunnel && !busy && !pending && !portraitId && root.dataset.photosReady === "true") $("[data-paint]").textContent = "Generate in " + styleName(style);
      if (creditBalance?.total === 0 && !busy && !pending && !(portraitId && !completed)) {
        $("[data-paint]").disabled = true;
        $("[data-retry]").disabled = true;
        $("[data-same-photos]").disabled = true;
        $(".pw-change button").disabled = true;
      }
      if (isFunnel && phase === "product" && canBuy) $("[data-mobile-action]").textContent = $("[data-cart]").textContent;
      if (styleBrowser.hasAttribute("open")) updateStyleAction();
      window.PawntedCart?.syncControls();
    }
    function optionsChanged() {
      save();
      if (busy) return;
      if (completed) approved = false;
      status(artworkChanged() ? "Your choices have changed. Create your updated portrait to see them before you buy." : "");
      updateControls();
    }
    $("[data-name]").oninput = optionsChanged;
    backgroundSelect.onchange = () => { syncBackgroundSwatches(); optionsChanged(); };
    backgroundRadios.forEach(radio => {
      radio.onchange = () => {
        if (!radio.checked || radio.disabled) return;
        backgroundSelect.value = radio.value;
        syncBackgroundSwatches();
        optionsChanged();
      };
    });
    function setPhase(next) {
      const previous = phase;
      phase = next;
      if (root.dataset.stage !== next) delete root.dataset.showCredits;
      root.dataset.stage = next;
      root.dataset.approved = String(approved);
      if (previous !== next) $("[data-announcement]").textContent = next === "waiting" ? "Creating your portrait. Your preview will appear when ready." : next === "product" ? "Choose your print size and finish." : next === "upload" ? "Edit your photos, background or artwork name." : "";
      updateControls();
    }
    function loading(active, title = "Creating your portrait.") {
      $("[data-loading]").hidden = !active;
      $("[data-loading-title]").textContent = title;
      $("[data-visual]").setAttribute("aria-busy", String(active));
      $("[data-visual]").classList.toggle("pw-is-loading", active);
      if (!active) stopProgress();
    }
    function showStyle() {
      const item = styles.find((s) => s.id === style) || styles[0];
      if (!item) return;
      style = item.id;
      $("[data-current-style-thumb]").src = item.image;
      $("[data-current-style-name]").textContent = item.name;
      $("[data-style-title]").textContent = item.name;
      $("[data-style-description]").textContent =
        item.description || "Their face. A whole new vibe.";
      if (!completed) {
        root.dataset.generated = "false";
        $(".pw-preview").src = item.image;
        $(".pw-preview").alt = item.name + " style example";
        $("[data-image-label]").textContent =
          "Style example · made personal with your photos";
      }
    }
    async function refreshCredits() {
      try {
        await ensureSession();
        const {balance} = await api("credits");
        creditBalance = balance;
        $("[data-credit-total]").textContent = `${balance.total} portrait${balance.total === 1 ? "" : "s"} left`;
        creditBadgeCount.textContent = `${balance.total} left`;
        $("[data-credit-breakdown]").textContent = balance.paid ? `${balance.free} free today + ${balance.paid} extra` : `${balance.free} free today`;
        const reset = new Date(balance.resetsAt);
        $("[data-credit-reset]").textContent = `Next free refill: ${reset.toLocaleDateString(undefined,{month:"short",day:"numeric"})}, ${reset.toLocaleTimeString(undefined,{hour:"numeric",minute:"2-digit"})}.`;
        $("[data-credit-status]").textContent = "";
        updateControls();
      } catch { $("[data-credit-status]").textContent = "Could not load your balance. Tap refresh to try again."; }
    }
    $("[data-refresh-credits]").onclick = refreshCredits;
    creditBadge.onclick = () => { root.dataset.showCredits = "true"; $(".pw-credit-card").scrollIntoView({behavior:"smooth",block:"center"}); $("[data-credit-topup]").focus({preventScroll:true}); void refreshCredits(); };
    let topupBusy = false;
    $("[data-credit-topup]").onclick = async () => {
      const button = $("[data-credit-topup]");
      if (cartIntent || busy || pending || topupBusy || button.disabled) return {error:"Please wait for your current portrait to finish."};
      topupBusy = true; button.disabled = true;
      $("[data-credit-status]").textContent = "Adding 20 generations to your bag...";
      try {
        await ensureSession(); save();
        const {item} = await api("credits", {});
        const cartRoot = window.Shopify?.routes?.root || "/";
        const cartResponse = await fetchBounded(cartRoot + "cart.js");
        if (!cartResponse.ok) throw new Error("Could not check your bag. Please try again.");
        const cart = await cartResponse.json();
        const hasCredit = bag => bag.items?.some(line => String(line.variant_id) === String(item.id) && line.properties?._pawnted_credit_wallet === item.properties._pawnted_credit_wallet);
        if (!hasCredit(cart)) {
          try {
            const response = await fetchBounded(cartRoot + "cart/add.js", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({items:[item]})});
            if (!response.ok) throw new Error("Could not add credits. Please try again.");
          } catch(error) {
            const check = await fetchBounded(cartRoot + "cart.js");
            if (!check.ok || !hasCredit(await check.json())) throw error;
          }
        }
        const link = document.createElement("a");
        link.href = cartRoot + "cart"; link.textContent = "20 generations are in your bag. View bag";
        $("[data-credit-status]").replaceChildren(link);
        await window.PawntedCart?.open({trigger:button,announcement:"20 generation credits are in your bag. They unlock after payment."});
        return {ok:true};
      } catch(error) { $("[data-credit-status]").textContent = error.message; return {error:error.message}; }
      finally { topupBusy = false; button.disabled = false; window.PawntedCart?.syncControls(); }
    };
    window.addEventListener("focus", () => { if (visitor) void refreshCredits(); });
    async function ensureSession() {
      if (visitor && Number(visitor.split(".")[1]) > Date.now() / 1000) return;
      if (visitor) { stored = {...stored,visitor}; visitor = ""; sessionPromise = null; }
      if (!sessionPromise)
        sessionPromise = api("session", {previousVisitor: stored?.visitor})
          .then((data) => {
            visitor = data.visitor;
            stored = {...stored,visitor};
            if (!styles.length) {
              styles = data.styles;
              showStyle();
            }
            save();
          })
          .catch((error) => {
            sessionPromise = null;
            throw error;
          });
      return sessionPromise;
    }
    function resetPortrait() {
      versions = []; historyUnavailable = false;
      stopProgress();
      previewRevision++;
      portraitId = "";
      previousPortraitId = "";
      pending = null;
      completed = false;
      approved = false;
      previewReady = false;
      texture = "";
      view = "artwork";
      root.dataset.previewView = "artwork";
      $("[data-visual]").style.setProperty("--pw-art-ratio", "4/5");
      $("[data-artwork-view]").hidden = false;
      $("[data-rotator]").hidden = true;
      $("[data-reset-view]").hidden = true;
      $(".pw-change").hidden = true;
      $("[data-visual-caption]").textContent =
        "Same style. Your favourite faces. Preview before you pay.";
      root
        .querySelectorAll("[data-view]")
        .forEach((button) =>
          button.setAttribute(
            "aria-pressed",
            String(button.dataset.view === "artwork"),
          ),
        );
      showStyle();
      loading(false);
      setPhase("upload");
      save();
    }
    const themeNames = {all:"All styles", retro:"60s, 70s & 80s", pets:"Pets", western:"Western", royal:"Royal", family:"Family", engagement:"Couples", fantasy:"Fantasy", "film-memes":"Film & fun", photography:"Photography", digital:"Digital art"};
    const styleBrowser = $("[data-style-browser]");
    let proposedStyle = style, styleScroll = 0;
    const generationCost = () => !creditBalance ? "Checking your preview allowance…" : creditBalance.free > 0
      ? `Uses 1 free preview · ${creditBalance.free} left today`
      : creditBalance.paid > 0 ? `Uses 1 purchased credit · ${creditBalance.paid} left`
      : "No previews left. Free previews refill daily.";
    function updateStyleAction() {
      const hasPhotos = Boolean(files.length || reuseSourceId || completed);
      $("[data-style-source]").textContent = hasPhotos ? (library.length ? `Using your existing photos. Your previous portraits stay saved.` : `Using the photos you added.`) : "Choose a style, then add your photos.";
      $("[data-style-confirm]").textContent = hasPhotos ? (isFunnel ? "Create in " : "Generate in ") + styleName(proposedStyle) : "Use " + styleName(proposedStyle);
      $("[data-style-confirm]").disabled = busy || hashing || Boolean(pending) || (hasPhotos && creditBalance?.total === 0);
      $("[data-style-cost]").textContent = hasPhotos ? generationCost() : "Browsing is free. No card needed.";
    }
    function closeStyles() {
      styleScroll = styleBrowser.scrollTop;
      if (styleBrowser.close) styleBrowser.close(); else styleBrowser.removeAttribute("open");
      $(".pw-styles").hidden = true; $("[data-change-style]").setAttribute("aria-expanded", "false");
      document.documentElement.classList.remove("pw-art-open"); $("[data-change-style]").focus({preventScroll:true});
    }
    function chooseStyle(id) {
      if (busy || versionLoading || pending || hashing || !styles.some(item => item.id === id)) return false;
      if (style !== id || (isFunnel && completed)) {
        const previous = completed ? portraitId : "";
        if (completed) reuseSourceId = portraitId;
        style = id; resetPortrait(); closeLibrary(); syncAddress();
        if (previous) previousPortraitId = previous;
      }
      track("funnel_style_selected", {reusedPhotos: Boolean(files.length || reuseSourceId)});
      $("[data-photo-panel]").open = true;
      if (isFunnel) editPhotos();
      return true;
    }
    function renderStyles() {
      $(".pw-styles").replaceChildren();
      const query = $("[data-style-search]").value.trim().toLowerCase();
      const matches = styles.filter(item => (styleTheme === "all" || item.theme === styleTheme) && [item.name,item.description,item.theme,themeNames[item.theme],item.medium].join(" ").toLowerCase().includes(query));
      $("[data-style-results]").textContent = matches.length ? matches.length + " styles to make your own" : "No styles found. Try another search or theme.";
      for (const item of matches) {
        const button = document.createElement("button");
        button.type = "button";
        button.setAttribute("aria-pressed", String(proposedStyle === item.id));
        const image = document.createElement("img");
        image.src = item.image;
        image.alt = item.name;
        image.loading = "lazy";
        image.width = 160;
        image.height = 200;
        const label = document.createElement("span");
        label.textContent = item.name;
        const description = document.createElement("small"); description.textContent = item.description || "Make it yours";
        button.append(image, label, description);
        button.dataset.browseStyle = item.id;
        button.onclick = () => {
          proposedStyle = item.id;
          root.querySelectorAll("[data-browse-style]").forEach(node => node.setAttribute("aria-pressed", String(node.dataset.browseStyle === proposedStyle)));
          updateStyleAction();
        };
        $(".pw-styles").append(button);
      }
    }
    async function openStyles() {
      if (busy || pending || hashing) return;
      try {
        if (!styles.length) await ensureSession();
        proposedStyle = style;
        $("[data-style-filters]").replaceChildren(...["all", ...new Set(styles.map(item => item.theme).filter(Boolean))].map(theme => {
          const button = document.createElement("button"); button.type = "button"; button.className = "pw-secondary";
          button.textContent = themeNames[theme] || theme; button.dataset.styleTheme = theme;
          button.setAttribute("aria-pressed", String(styleTheme === theme));
          button.onclick = () => {styleTheme = theme; root.querySelectorAll("[data-style-theme]").forEach(node => node.setAttribute("aria-pressed", String(node === button))); renderStyles();};
          return button;
        }));
        renderStyles(); updateStyleAction(); $(".pw-styles").hidden = false;
        $("[data-change-style]").setAttribute("aria-expanded", "true");
        if (styleBrowser.showModal) styleBrowser.showModal(); else styleBrowser.setAttribute("open", "");
        document.documentElement.classList.add("pw-art-open"); $("[data-close-styles]").focus({preventScroll:true});
        styleBrowser.scrollTop = styleScroll;
        track("style_picker_opened", {reusedPhotos: Boolean(files.length || reuseSourceId || completed)});
      } catch (error) { status(error.message); }
    }
    $("[data-change-style]").onclick = () => styleBrowser.hasAttribute("open") ? closeStyles() : openStyles();
    $("[data-browse-styles]").onclick = openStyles;
    $("[data-another-style]").onclick = openStyles;
    $("[data-mobile-style]").onclick = openStyles;
    $("[data-reveal-style]").onclick = openStyles;
    $("[data-style-confirm]").onclick = async () => {
      if ($("[data-style-confirm]").disabled) return;
      const previous = completed ? portraitId : "";
      const ready = Boolean(files.length || reuseSourceId || completed);
      if (!chooseStyle(proposedStyle)) return;
      closeStyles();
      if (ready) {
        if (previous && !completed) previousPortraitId = previous;
        await paint();
      } else { editPhotos(); if (files.length || reuseSourceId) focusWork("[data-files]"); }
    };
    $("[data-style-change-photos]").onclick = () => {closeStyles(); changePhotos();};
    $("[data-keep-creating]").onclick = () => { if (isFunnel) return openOptions(true); focusWork("[data-new-portrait]"); $("[data-new-photos]").focus({preventScroll:true}); };
    function prepareBackNavigation() {
      if (cartIntent || pending || hashing || topupBusy || (busy && !versionLoading)) return false;
      if (versionLoading) {
        versionEpoch++; previewRevision++; queuedVersion=null;versionTargetId="";
        versionLoading=false;busy=false;loading(false);updateControls();
      }
      return true;
    }
    function canOpenPrint() {
      return !cartIntent && !busy && !versionLoading && !pending && !hashing && !topupBusy &&
        (completed || recentPortraits().length > 0);
    }
    window.PawntedStudio = {
      startCartPair,
      openPrint: ({quiet = false} = {}) => {
        if (!canOpenPrint()) return false;
        // Returning to the open artwork is a local step change, not another restore.
        if (completed && portraitId) {
          approved = true; setPhase("product"); save();
          void refreshPreview();
          return true;
        }
        const id = completed ? portraitId : recentPortraits().at(-1)?.id;
        if (id) return chooseVersion(id, true, quiet);
        return false;
      },
      preparePrintOptions: () => ensureCatalog().catch(() => {}),
      getState: () => ({canOpenPrint:canOpenPrint(),resumeOnReload,canNavigateBack:!cartIntent && !pending && !hashing && !topupBusy && (!busy || versionLoading),busy:cartIntent || busy || versionLoading || Boolean(pending) || topupBusy || hashing,hasPortrait:completed,libraryCount:library.length,stage:phase,style,portraitId,hasPhotos:Boolean(files.length || reuseSourceId),approved,previewReady,credits:creditBalance}),
      chooseStyle,
      prepareBackNavigation,
      backToPhotos: () => { if (!prepareBackNavigation()) return false; editPhotos(); return true; },
      openStyles,
      navigate: async state => {
        if (busy || pending || hashing) return false;
        const epoch = versionEpoch;
        if (styleBrowser.hasAttribute("open")) closeStyles();
        if (state.portraitId && state.portraitId !== portraitId && recentPortraits().some(item => item.id === state.portraitId)) await chooseVersion(state.portraitId);
        else if (!state.portraitId && state.style && state.style !== style) chooseStyle(state.style);
        if (epoch !== versionEpoch) return false;
        if (state.stage === "upload") editPhotos();
        else if (state.stage === "product" && approved) setPhase("product");
        else if (completed) reviewPortrait();
        return true;
      },
      addCredits: () => $("[data-credit-topup]").onclick(),
      continueCreating: action => {
        if (busy || pending) return;
        if (action === "library") return openLibrary();
        if (action === "styles") return openStyles();
        if (completed) return $("[data-keep-creating]").onclick();
        editPhotos();
      },
    };
    const recordedCartArtwork = new Set();
    function recordCartArtwork(id, variantId, evidence) {
      if (!visitor || !/^[a-f0-9-]{36}$/i.test(id || "") || !/^\d+$/.test(String(variantId || ""))) return;
      const key = id + ":" + variantId;
      if (recordedCartArtwork.has(key)) return;
      recordedCartArtwork.add(key);
      // Never await analytics on the purchase path. Only call after Shopify has
      // returned a successful add or an actual cart containing this artwork.
      void fetch(url("commerce-event"), {method:"POST",headers:{"Content-Type":"application/json"},keepalive:true,
        body:JSON.stringify({id,variantId:String(variantId),evidence})
      }).then(response=>{if(!response.ok)recordedCartArtwork.delete(key);}).catch(()=>recordedCartArtwork.delete(key));
    }
    window.addEventListener("pawnted:cart-updated", event => {
      if(printPair?.done && !cartIntent && !pairInBag(event.detail?.cart||{items:[]},pairVariant())){printPair.done=false;savePair();renderPair();}
      for (const item of event.detail?.cart?.items || []) {
        const id = item.properties?._pawnted_portrait_id;
        if (library.some(p=>p.id===id)) recordCartArtwork(id,item.properties?._pawnted_base_variant || item.variant_id,"cart_observed");
      }
      if (addedKey !== cartKey() || !Array.isArray(event.detail?.cart?.items)) return;
      const stillInBag = event.detail.cart.items.some(item => item.properties?._pawnted_portrait_id === portraitId && String(item.properties?._pawnted_base_variant || item.variant_id) === String(selected()?.id));
      if (!stillInBag) {addedKey="";updateControls();}
    });
    $("[data-close-styles]").onclick = closeStyles;
    $("[data-style-search]").oninput = renderStyles;
    styleBrowser.addEventListener("cancel", event => {event.preventDefault(); closeStyles();});
    styleBrowser.addEventListener("click", event => {if (event.target === styleBrowser) closeStyles();});
    styleBrowser.addEventListener("keydown", event => {if (event.key === "Escape") {event.preventDefault(); closeStyles();}});
    function options(select, entries, wanted) {
      select.replaceChildren(
        ...entries.map(([value, label]) => {
          const option = document.createElement("option");
          option.value = value;
          option.textContent = label;
          return option;
        }),
      );
      select.value = entries.some(([value]) => value === wanted)
        ? wanted
        : entries[0]?.[0] || "";
    }
    function choices(select, container, kind) {
      container.replaceChildren(
        ...[...select.options].map((option) => {
          const button = document.createElement("button");
          button.type = "button";
          button.className = "pw-choice";
          button.setAttribute(
            "aria-pressed",
            String(option.value === select.value),
          );
          if (kind === "frame") {
            const swatch = document.createElement("span");
            swatch.className = option.value
              ? "pw-swatch pw-swatch-walnut"
              : "pw-swatch";
            swatch.setAttribute("aria-hidden", "true");
            button.append(swatch);
          }
          const label = document.createElement("span");
          label.textContent = option.textContent;
          button.append(label);
          if (kind === "product") {
            const price = document.createElement("small");
            price.textContent =
              "from " +
              money(
                Math.min(
                  ...variants
                    .filter((v) => v.productType === option.value)
                    .map((v) => Number(v.price)),
                ),
              );
            button.append(price);
          }
          button.onclick = () => {
            select.value = option.value;
            select.onchange();
          };
          return button;
        }),
      );
    }
    function renderChoices() {
      choices($("[data-product]"), $("[data-product-choices]"), "product");
      choices($("[data-size]"), $("[data-size-choices]"), "size");
      choices($("[data-frame]"), $("[data-frame-choices]"), "frame");
    }
    function hasSaving(variant) {
      return Number.isFinite(Number(variant.compareAtPrice)) && Number(variant.compareAtPrice) > Number(variant.price);
    }
    function renderPrice() {
      const choosingPrint = phase === "product" || phase === "cart";
      // A remembered frame/size belongs to print selection. Uploading and
      // browsing styles always show the available starting price instead.
      const v = choosingPrint ? selected() : variants.reduce((lowest, item) =>
        !lowest || Number(item.price) < Number(lowest.price) ? item : lowest, null);
      if (!v) return;
      const price = (choosingPrint ? "" : "From ") + money(v.price);
      if ($("[data-price]")) $("[data-price]").textContent = price;
      $("[data-mobile-price]").textContent = price;
      root.querySelectorAll("[data-compare-price]").forEach(node => {
        node.hidden = !hasSaving(v); node.textContent = hasSaving(v) ? money(v.compareAtPrice) : "";
      });
      if ($("[data-savings]")) $("[data-savings]").hidden = false;
      if ($("[data-savings]")) { $("[data-savings]").hidden = !v.pairPrice; $("[data-savings]").textContent = v.pairPrice ? "2 for " + money(v.pairPrice) : ""; }
      const finish = v.productType === "canvas" ? "canvas" : "print";
      if ($("[data-price-context]")) $("[data-price-context]").textContent = "USD \u00b7 " + v.size.replace("x", " \u00d7 ") + " in " + finish +
        (v.frameColor ? " + " + v.frameColor.toLowerCase() + " frame" : "") + " \u00b7 Free shipping";
    }
    function selectLayout() {
      previewReady = false;
      previewRevision++;
      const v = selected();
      if (!v) {
        updateControls();
        return;
      }
      selection = {
        productType: v.productType,
        size: v.size,
        frameColor: v.frameColor || "",
      };
      if (completed && portraitId) printSelections[portraitId] = {...selection};
      save();
      $("[data-material-note]").textContent =
        v.productType === "canvas"
          ? v.frameColor
            ? "Stretched canvas + walnut floating frame. Ready for their close-up."
            : "Textured stretched canvas, mirrored edges. No outer frame."
          : "Archival matte fine art paper. Ready for a frame of your own.";
      renderChoices();
      updateControls();
      if (completed && !busy) void refreshPreview();
    }
    function frames(wanted = $("[data-frame]").value) {
      const items = variants.filter(
        (v) =>
          v.productType === $("[data-product]").value &&
          v.size === $("[data-size]").value,
      );
      options(
        $("[data-frame]"),
        items.map((v) => [
          v.frameColor || "",
          v.frameColor ? v.frameColor + (items.some(item => !item.frameColor)
            ? " +" + money(Number(v.price) - Number(items.find(item => !item.frameColor).price)) : "") : "No frame",
        ]),
        wanted,
      );
      $("[data-frame-label]").hidden =
        items.length < 2 && !items[0]?.frameColor;
      selectLayout();
    }
    function sizes(
      wanted = $("[data-size]").value,
      frame = $("[data-frame]").value,
    ) {
      const items = [
        ...new Set(
          variants
            .filter((v) => v.productType === $("[data-product]").value)
            .map((v) => v.size),
        ),
      ];
      options(
        $("[data-size]"),
        items.map((size) => [
          size,
          $("[data-unit]").value === "cm"
            ? size
                .split("x")
                .map((n) => (Number(n) * 2.54).toFixed(1))
                .join(" × ") + " cm"
            : size.replace("x", " × ") + " in",
        ]),
        wanted,
      );
      frames(frame);
    }
    $("[data-product]").onchange = () => sizes();
    $("[data-size]").onchange = () => frames();
    $("[data-frame]").onchange = selectLayout;
    $("[data-unit]").onchange = () => sizes();
    async function ensureCatalog() {
      if (variants.length) return;
      if (!catalogPromise) {
        $("[data-reload-products]").hidden = true;
        $("[data-catalog-loading]").hidden = false;
        catalogPromise = api("products")
          .then((data) => {
            variants = Array.isArray(data.variants) ? data.variants : [];
            if (!variants?.length)
              throw new Error("Print options are temporarily unavailable.");
            options(
              $("[data-product]"),
              [...new Set(variants.map((v) => v.productType))].map((type) => [
                type,
                type === "canvas"
                  ? "Canvas"
                  : type === "standard_print"
                    ? "Print"
                    : "Framed print",
              ]),
              selection.productType,
            );
            $("[data-options]").hidden = false;
            $("[data-catalog-loading]").hidden = true;
            $("[data-finish]").setAttribute("aria-busy", "false");
            sizes(selection.size || "8x10", selection.frameColor);
          })
          .catch((error) => {
            catalogPromise = null;
            $("[data-catalog-loading]").hidden = true;
            $("[data-reload-products]").hidden = false;
            $("[data-finish]").setAttribute("aria-busy", "false");
            throw error;
          });
      }
      return catalogPromise;
    }
    $("[data-reload-products]").onclick = async () => {
      try { await ensureCatalog(); if (completed) await refreshPreview(); }
      catch (error) { status(error.message); }
    };
    async function getTexture(id, v) {
      // One private, low-resolution image is shared by flat/3D views and frame options.
      const key = [id, v?.size || "original", v?.productType || "", v?.productType === "framed"].join(
        ":",
      );
      if (!imageCache.has(key)) {
        const entry = {};
        entry.promise = (async () => {
          const response = await fetchBounded(
            url("preview", {
              id,
              ...(v ? { size: v.size, productType: v.productType,
                framed: v.productType === "framed" ? "1" : "0" } : {}),
            }),
          );
          if (
            !response.ok ||
            !response.headers.get("content-type")?.startsWith("image/")
          )
            throw new Error(
              "The print preview could not load. Please choose your size again.",
            );
          const objectUrl = URL.createObjectURL(await response.blob());
          try {
            const probe = new Image();
            if (probe.decode) {
              probe.src = objectUrl;
              await probe.decode();
            } else
              await new Promise((resolve, reject) => {
                probe.onload = resolve;
                probe.onerror = () =>
                  reject(
                    new Error(
                      "Your preview could not be displayed. Please choose the size again.",
                    ),
                  );
                probe.src = objectUrl;
              });
            entry.ratio = (probe.naturalWidth || 800) + "/" + (probe.naturalHeight || 1000);
            if (!v) {
              const saved = library.find(item => item.id === id);
              if (saved && saved.previewRatio !== entry.ratio) { saved.previewRatio = entry.ratio; save(); }
            }
          } catch (error) {
            URL.revokeObjectURL(objectUrl);
            throw error;
          }
          entry.url = objectUrl;
          // Bound memory when visitors explore lots of sizes/retries.
          if (imageCache.size > 12)
            for (const [oldKey, old] of imageCache) {
              if (imageCache.size <= 12) break;
              if (oldKey !== key && old.url && old.url !== texture && old.url !== $(".pw-preview").src &&
                  !(compareDialog.hasAttribute("open") && [...root.querySelectorAll("[data-compare-image]")].some(image => image.src === old.url))) {
                URL.revokeObjectURL(old.url);
                imageCache.delete(oldKey);
              }
            }
          return objectUrl;
        })().catch((error) => {
          imageCache.delete(key);
          throw error;
        });
        imageCache.set(key, entry);
      }
      return imageCache.get(key).promise;
    }
    function showOriginalArtwork(source, ratio) {
      $(".pw-preview").src = source;
      $(".pw-preview").alt = "Your complete portrait in its original proportions";
      const artwork = [...imageCache.values()].find(entry => entry.url === source);
      const dimensions = (artwork?.ratio || ratio || "4/5").split("/").map(Number);
      $(".pw-preview").width = dimensions[0]; $(".pw-preview").height = dimensions[1];
      $("[data-visual]").style.setProperty("--pw-art-ratio", dimensions.join("/"));
    }
    async function refreshPreview() {
      const v = phase === "product" ? selected() : undefined,
        id = portraitId,
        revision = ++previewRevision;
      if (!completed || busy) return;
      previewReady = false;
      updateControls();
      if (!(isFunnel && versionLoading) && !quietResume && !(textureReady(id) && (isFunnel || !v || textureReady(id, v)))) {
        loading(true, "Bringing your portrait into focus.");
        progressFloor = 97;
        if (progressValue === 100) { progressValue = 0; showProgress(97); }
        else showProgress(97);
      }
      $("[data-waiting-text]").textContent = v ? "Loading your exact print layout. No surprise cropping." : "Your portrait is ready. Bringing every detail into view.";
      try {
        const artwork = await getTexture(id);
        const source = v ? await getTexture(id, v) : artwork;
        if (revision !== previewRevision || id !== portraitId || busy) return;
        texture = source;
        root.dataset.generated = "true";
        showOriginalArtwork(artwork);
        $(".pw-layout").src = source;
        if (v) rotator?.update(v, source);
        previewReady = true;
        if (acceptedAt.has(id)) track("preview_visible", {durationMs: Date.now() - acceptedAt.get(id)}, id);
        $("[data-image-label]").textContent =
          versionLabel(id) + (v ? " · " + v.size.replace("x", " × ") + " in" : " · Your portrait");
        $("[data-visual-caption]").textContent =
          view === "3d"
            ? "Drag to turn. Frame and wrap are illustrations; grain and colour may vary."
            : v ? "Your complete artwork. See the selected size and frame in 3D preview." : "Made for you. Tap Full screen to see every detail.";
        stopProgress(true);
        if (isFunnel && phase === "preview" && $(".pw-change").hidden) {
          approved = true; track("print_options_viewed", {}, portraitId); setPhase("product"); void refreshPreview(); return;
        }
        $("[data-announcement]").textContent = phase === "product" ? "Your selected print preview is ready." : "Your portrait is ready. View it, zoom in, then approve it or request a change.";
        loading(false);
        $("[data-resume]").hidden = true;
        updateControls();
      } catch (error) {
        if (revision !== previewRevision || id !== portraitId) return;
        // A print-layout failure must not hide the finished painting. Keep
        // checkout locked until the selected layout has loaded successfully.
        if (v) {
          try {
            const source = await getTexture(id);
            if (revision !== previewRevision || id !== portraitId) return;
            showOriginalArtwork(source);
            root.dataset.generated = "true";
            await switchView("artwork");
            loading(false);
            status("Your portrait is ready. Reload the print options to check its size layout.");
            $("[data-reload-products]").hidden = false;
            updateControls();
            return;
          } catch {}
        }
        if (!(isFunnel && versionLoading)) loading(true, "Let’s reconnect your preview.");
        stopProgress();
        $("[data-resume]").hidden = false;
        status(error.message);
        updateControls();
      }
    }
    async function loadRotator() {
      if (rotator) return rotator;
      if (!window.PawntedRotator) {
        if (!window.pawntedRotatorLoading)
          window.pawntedRotatorLoading = new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = root.dataset.rotatorSrc;
            script.async = true;
            script.onload = resolve;
            script.onerror = () => {
              script.remove();
              window.pawntedRotatorLoading = null;
              reject(
                new Error(
                  "3D could not load. Your artwork preview is still available.",
                ),
              );
            };
            document.head.append(script);
          });
        await window.pawntedRotatorLoading;
      }
      if (!rotator) rotator = new window.PawntedRotator($("[data-rotator]"));
      return rotator;
    }
    async function switchView(next) {
      if (next === "3d" && (phase !== "product" || !previewReady || busy || !selected())) return;
      view = next;
      if (next === "3d") {
        try {
          await loadRotator();
        } catch (error) {
          view = "artwork";
          status(error.message);
          return;
        }
        if (!previewReady || busy || view !== next) return;
      }
      $("[data-artwork-view]").hidden = next === "3d";
      root.dataset.previewView = next;
      $("[data-rotator]").hidden = next !== "3d";
      $("[data-reset-view]").hidden = next !== "3d";
      root
        .querySelectorAll("[data-view]")
        .forEach((button) =>
          button.setAttribute(
            "aria-pressed",
            String(button.dataset.view === next),
          ),
        );
      if (next === "3d") {
        rotator.update(selected(), texture);
        requestAnimationFrame(() => rotator.resize());
      }
      $("[data-visual-caption]").textContent =
        next === "3d"
          ? "Drag to turn. Frame and wrap are illustrations; grain and colour may vary."
          : "Your complete artwork. See the selected size and frame in 3D preview.";
    }
    root.querySelectorAll("[data-view]").forEach((button) => {
      button.onclick = () => switchView(button.dataset.view);
    });
    $("[data-reset-view]").onclick = () => rotator?.reset();
    // A native dialog works in mobile in-app browsers without Fullscreen API
    // permissions. Reuse the displayed preview; no extra image download.
    const lightbox = $("[data-lightbox]");
    const zoomViewport = $("[data-zoom-viewport]"), zoomImage = $("[data-zoom-image]");
    let zoom = 1, panX = 0, panY = 0, fitWidth = 0, fitHeight = 0, pinchDistance = 0, lastTap = 0;
    const pointers = new Map();
    function drawZoom() {
      panX = Math.max(-Math.max(0, (fitWidth * zoom - zoomViewport.clientWidth) / 2), Math.min(Math.max(0, (fitWidth * zoom - zoomViewport.clientWidth) / 2), panX));
      panY = Math.max(-Math.max(0, (fitHeight * zoom - zoomViewport.clientHeight) / 2), Math.min(Math.max(0, (fitHeight * zoom - zoomViewport.clientHeight) / 2), panY));
      zoomImage.style.transform = `translate(${panX}px, ${panY}px) scale(${zoom})`;
      $("[data-zoom-level]").textContent = Math.round(zoom * 100) + "%";
      $("[data-zoom-out]").disabled = zoom <= 1;
      $("[data-zoom-in]").disabled = zoom >= 3;
      zoomViewport.style.cursor = zoom > 1 ? "grab" : "zoom-in";
    }
    function setZoom(value) { zoom = Math.max(1, Math.min(3, value)); drawZoom(); }
    function fitZoom() {
      const img = $("[data-enlarged-preview]");
      const ratio = (img.naturalWidth || 800) / (img.naturalHeight || 1000);
      fitWidth = Math.min(zoomViewport.clientWidth, zoomViewport.clientHeight * ratio);
      fitHeight = fitWidth / ratio;
      zoomImage.style.width = fitWidth + "px";
      zoomImage.style.height = fitHeight + "px";
      panX = panY = 0; pointers.clear(); pinchDistance = 0; setZoom(1);
    }
    $("[data-zoom-in]").onclick = () => setZoom(zoom + 0.5);
    $("[data-zoom-out]").onclick = () => setZoom(zoom - 0.5);
    $("[data-zoom-reset]").onclick = fitZoom;
    $("[data-enlarged-preview]").onload = fitZoom;
    $("[data-artwork-view]").onclick = () => $("[data-expand]").onclick();
    zoomViewport.addEventListener("wheel", event => { event.preventDefault(); setZoom(zoom + (event.deltaY < 0 ? 0.25 : -0.25)); }, { passive: false });
    const distance = () => { const [a, b] = [...pointers.values()]; return a && b ? Math.hypot(a.x - b.x, a.y - b.y) : 0; };
    let gestureMoved = false;
    zoomViewport.addEventListener("pointerdown", event => {
      if (event.button && event.button !== 0) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      zoomViewport.setPointerCapture?.(event.pointerId);
      if (pointers.size === 1) gestureMoved = false;
      if (pointers.size > 1) { gestureMoved = true; pinchDistance = distance(); }
    });
    zoomViewport.addEventListener("pointermove", event => {
      const previous = pointers.get(event.pointerId); if (!previous) return;
      const dx = event.clientX - previous.x, dy = event.clientY - previous.y;
      if (Math.abs(dx) + Math.abs(dy) > 3) gestureMoved = true;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (pointers.size === 2) { const next = distance(); if (pinchDistance) setZoom(zoom * next / pinchDistance); pinchDistance = next; }
      else if (zoom > 1) { panX += dx; panY += dy; drawZoom(); }
    });
    const endPointer = event => {
      if (event.type === "pointerup" && !gestureMoved && pointers.size === 1) {
        const now = Date.now(); if (lastTap && now - lastTap < 350) { setZoom(zoom > 1 ? 1 : 2); lastTap = 0; } else lastTap = now;
      }
      pointers.delete(event.pointerId); pinchDistance = distance();
    };
    for (const type of ["pointerup", "pointercancel", "lostpointercapture"]) zoomViewport.addEventListener(type, endPointer);
    window.addEventListener("resize", () => { if (lightbox.hasAttribute("open")) fitZoom(); });
    // Discourage casual saving without blocking scrolling, pinch zoom, or
    // thumb rotation. This cannot prevent screenshots or developer tools.
    for (const surface of [$("[data-visual]"), lightbox]) {
      for (const event of ["contextmenu", "dragstart", "copy"])
        surface.addEventListener(event, (e) => e.preventDefault());
      surface.querySelectorAll("img").forEach((img) => img.setAttribute("draggable", "false"));
    }
    let returnFocus;
    const restoreLightboxFocus = () => {
      document.documentElement.classList.remove("pw-art-open");
      (returnFocus || $("[data-expand]")).focus({ preventScroll: true });
    };
    $("[data-expand]").onclick = () => {
      if (busy || (completed && !previewReady) || !$(".pw-preview").src) return;
      returnFocus = document.activeElement;
      $("[data-enlarged-preview]").src =
        $(".pw-preview").currentSrc || $(".pw-preview").src;
      $("[data-lightbox-caption]").textContent =
        $("[data-image-label]").textContent;
      document.documentElement.classList.add("pw-art-open");
      if (typeof lightbox.showModal === "function") lightbox.showModal();
      else {
        lightbox.setAttribute("open", "");
        lightbox.setAttribute("aria-modal", "true");
      }
      $("[data-close-lightbox]").focus();
      requestAnimationFrame(fitZoom);
    };
    const closeLightbox = () => {
      if (typeof lightbox.close === "function") lightbox.close();
      else {
        lightbox.removeAttribute("open");
        restoreLightboxFocus();
      }
    };
    $("[data-close-lightbox]").onclick = closeLightbox;
    lightbox.addEventListener("close", restoreLightboxFocus);
    lightbox.addEventListener("click", (event) => {
      if (event.target === lightbox) closeLightbox();
    });
    lightbox.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        closeLightbox();
      } else if (event.key === "Tab") {
        const controls = [...lightbox.querySelectorAll("button, [tabindex='0']")].filter(node => !node.disabled);
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      } else if (["+", "=", "-", "0"].includes(event.key)) {
        event.preventDefault(); if (event.key === "0") fitZoom(); else setZoom(zoom + (event.key === "-" ? -0.5 : 0.5));
      }
    });
    const pause = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    function poll() {
      if (pollPromise) return pollPromise;
      pollPromise = (async () => {
        const id = portraitId,
          started = Date.now();
        let recoveringShown = false;
        busy = true;
        if (!progressTimer) startProgress();
        loading(true);
        setPhase("waiting");
        $("[data-resume]").hidden = true;
        $("[data-waiting-text]").textContent =
          "A new composition. Every little detail, created just for you.";
        while (Date.now() - started < 8 * 60 * 1000 && portraitId === id) {
          try {
            const result = await api("restore", undefined, { id });
            if (result.recovering) {
              $("[data-loading-title]").textContent = isFunnel ? "Almost there. Perfecting the details." : "Refining your portrait.";
              $("[data-waiting-text]").textContent = isFunnel ? "We spotted something small and we're giving it one more pass. No extra preview used." : "Your photos are saved. We're creating another version automatically, without using another retry.";
              // Restart the ring from the middle so the wait visibly moves again.
              if (isFunnel && !recoveringShown) { recoveringShown = true; progressStarted = Date.now() - 12000; progressValue = 0; progressFloor = 40; }
            }
            if (result.status === "completed") {
              previousPortraitId = "";
              completed = true;
              if (result.style) { style = result.style; showStyle(); syncAddress(); }
              restorePaintedOptions(result);
              rememberVersion(result, id);
              busy = false;
              approved = false;
              $("[data-photo-panel]").open = false;
              $("[data-photo-summary]").textContent =
                "Your photos are in. Change them here.";
              setPhase("preview");
              status("");
              // Product availability must not gate the artwork reveal.
              void ensureCatalog().catch((error) => status(error.message));
              await refreshPreview();
              save();
              return;
            }
            if (result.status === "failed") {
              track("generation_failed", {category: "generation", durationMs: acceptedAt.has(id) ? Date.now() - acceptedAt.get(id) : undefined}, id);
              busy = false;
              if (previousPortraitId && previousPortraitId !== id) {
                const previous = await api("restore", undefined, {id: previousPortraitId});
                if (previous.status === "completed") {
                  portraitId = previousPortraitId;
                  previousPortraitId = "";
                  completed = true;
                  approved = false;
                  style = previous.style || library.find(item => item.id === portraitId)?.style || style; showStyle(); syncAddress();
                  restorePaintedOptions(previous);
                  rememberVersion(previous, portraitId);
                  setPhase("preview");
                  await refreshPreview();
                  status((result.error || "This attempt could not finish.") + " Your previous portrait is still here. You can keep it or try again.");
                  save();
                  return;
                }
              }
              resetPortrait();
              reuseSourceId = id;
              save(); updateControls();
              status(
                result.error ||
                  "This portrait could not finish. Please try again.",
              );
              return;
            }
          } catch (error) {
            if ([401, 404].includes(error.httpStatus)) {
              status(error.message);
              break;
            }
            status(
              "Reconnecting to your portrait. Your portrait is still safe.",
            );
          }
          const elapsed = Date.now() - started;
          if (elapsed > 20000 && $("[data-loading-title]").textContent !== "Refining your portrait.")
            $("[data-waiting-text]").textContent =
              "Still creating. Some portraits need a little longer; your preview will appear automatically.";
          await pause(elapsed < 15000 ? 1000 : elapsed < 60000 ? 2000 : 5000);
        }
        busy = false;
        stopProgress();
        updateControls();
        $("[data-resume]").hidden = false;
        status(
          "Your portrait is taking longer than usual. Check again without starting a new portrait.",
        );
      })().finally(() => {
        pollPromise = null;
      });
      return pollPromise;
    }
    async function uploadFiles(chosen, revision) {
      await ensureSession();
      const paths = new Array(chosen.length);
      let index = 0;
      // Two direct-to-storage uploads at a time; no photos travel through the proxy.
      async function worker() {
        while (index < chosen.length && revision === photoRevision) {
          const i = index++,
            file = chosen[i];
          const signed = await api("upload", {
            type: file.type,
            size: file.size,
          });
          const response = await fetchBounded(
            signed.uploadUrl,
            {
              method: "PUT",
              headers: { "Content-Type": file.type, "x-upsert": "false" },
              body: file,
            },
            90000,
          );
          if (!response.ok)
            throw new Error("A photo upload failed. Please try again.");
          paths[i] = signed.path;
        }
      }
      await Promise.all([worker(), worker()]);
      if (revision !== photoRevision) return null;
      uploadedPaths = paths;
      track("upload_ready", {photoCount: chosen.length}, String(revision));
      return paths;
    }
    async function selectPhotos(chosen, fresh = false) {
      if (busy || pending || hashing) return;
      let revision = photoRevision;
      const total = chosen.length;
      hashing = true;
      updateControls();
      $("[data-files]").value = "";
      status("");
      try {
        if (total > 4)
          throw new Error(
            "Choose between 1 and 4 photos, one per pet or person.",
          );
        const hashes = new Set();
        for (const file of chosen) {
          if (
            !["image/jpeg", "image/png", "image/webp"].includes(file.type) ||
            !file.size ||
            file.size > 20 * 1024 * 1024
          )
            throw new Error("Use JPEG, PNG or WebP photos under 20 MB.");
          const hash = Array.from(
            new Uint8Array(
              await crypto.subtle.digest("SHA-256", await file.arrayBuffer()),
            ),
          ).join(",");
          if (revision !== photoRevision) return;
          if (hashes.has(hash))
            throw new Error(
              "This photo appears twice. Please choose one photo per pet or person.",
            );
          hashes.add(hash);
        }
        // Only replace the accepted selection after the entire candidate passes.
        // Cancelling the picker or rejecting an addition must preserve existing photos.
        revision = ++photoRevision;
        if (fresh) $("[data-name]").value = "";
        files = chosen; reuseSourceId = "";
        uploadedPaths = null;
        uploadPromise = null;
        resetPortrait();
        thumbUrls.forEach((source) => URL.revokeObjectURL(source));
        thumbUrls = [];
        $(".pw-photos").replaceChildren();
        $("[data-photo-panel]").open = true;
        $("[data-photo-summary]").textContent = "Start with one photo per pet or person";
        if (!total) return;
        status("");
        for (const [index, file] of files.entries()) {
          const item = document.createElement("div");
          item.className = "pw-photo-item";
          const image = document.createElement("img");
          image.alt = "Selected subject photo " + (index + 1);
          image.src = URL.createObjectURL(file);
          thumbUrls.push(image.src);
          const remove = document.createElement("button");
          remove.type = "button";
          remove.className = "pw-photo-remove";
          remove.dataset.removePhoto = String(index);
          remove.textContent = "Remove";
          remove.setAttribute("aria-label", "Remove photo " + (index + 1));
          remove.onclick = () => selectPhotos(files.filter((_, i) => i !== index));
          item.append(image, remove);
          $(".pw-photos").append(item);
        }
        $("[data-photo-summary]").textContent =
          files.length +
          (files.length === 1
            ? " photo added. One very good muse."
            : " photos added. The whole cast.");
        uploadPromise = uploadFiles(files, revision);
        // Attach a handler immediately so background failures never become unhandled rejections.
        uploadPromise.catch((error) => {
          if (revision === photoRevision && !busy) status(error.message);
        });
        void ensureCatalog().catch((error) => status(error.message));
        if (fresh) { status("New photos added. Create your next " + styleName(style) + " portrait below. Your previous portrait is saved in Your portraits."); focusWork("[data-photo-panel]"); }
      } catch (error) {
        if (revision === photoRevision) status(error.message);
      } finally {
        if (revision === photoRevision) {
          hashing = false;
          updateControls();
        }
      }
    }
    $("[data-files]").onchange = event => {
      const additions = [...(event.target.files || [])];
      // In the funnel, choosing photos after a finished portrait starts a new set rather than adding to the old one.
      const fresh = nextUploadIsFresh || (isFunnel && (completed || files.length >= 4)); nextUploadIsFresh = false;
      if (!additions.length) return;
      return selectPhotos(fresh ? additions : [...files, ...additions], fresh);
    };
    $("[data-files]").addEventListener("cancel", () => { nextUploadIsFresh = false; });
    function changePhotos() {
      if (busy || hashing || pending) return;
      nextUploadIsFresh = true; $("[data-files]").click();
    }
    $("[data-new-photos]").onclick = changePhotos;
    $("[data-ready-change]").onclick = changePhotos;
    $("[data-same-photos]").onclick = () => { if (completed) return paint(); };
    async function submitPending() {
      const request = pending;
      const result = await api("restore", pending);
      if (!result.id)
        throw new Error(
          "Your request is being saved. Use reconnect to check the same request.",
        );
      portraitId = result.id;
      if (!acceptedAt.has(result.id)) acceptedAt.set(result.id, Date.now());
      track("generation_started", {kind: request.change ? "edit" : request.sourceId ? library.find(item => item.id === request.sourceId)?.style !== style ? "another_style" : "version" : "first"}, result.id);
      pending = null;
      save();
      progressFloor = 25;
      await poll();
    }
    async function paint(change, editTicket) {
      if (busy || versionLoading || hashing || (!files.length && !completed && !pending && !reuseSourceId)) return;
      if (creditBalance?.total === 0 && !pending && !(portraitId && !completed)) {
        status("No previews left today. Your saved portraits are still available to view, compare and print.");
        return;
      }
      busy = true;
      approved = false;
      previewReady = false;
      previewRevision++;
      const retrying = completed;
      const sourceId = completed ? portraitId : reuseSourceId || undefined;
      if (retrying) previousPortraitId = sourceId;
      completed = false;
      startProgress();
      void switchView("artwork");
      loading(true, "Getting your stars ready.");
      if (files.length >= 3) $("[data-waiting-text]").textContent = "More faces take a little longer. We’re giving every one of them extra care.";
      setPhase("waiting");
      focusWork();
      status("");
      $("[data-resume]").hidden = true;
      $(".pw-change").hidden = true;
      try {
        await ensureSession();
        if (!pending) {
          let paths;
          if (!sourceId) {
            if (!uploadedPaths) {
              try {
                paths = await (uploadPromise ||
                  uploadFiles(files, photoRevision));
              } catch {
                uploadPromise = uploadFiles(files, photoRevision);
                paths = await uploadPromise;
              }
            } else paths = uploadedPaths;
          }
          pending = {
            requestId: crypto.randomUUID(),
            paths,
            sourceId,
            ...(sourceId && !change && savedPhotosKept && sourceId === savedPhotosFor ? {sourcePhotos: savedPhotosKept} : {}),
            style,
            name: $("[data-name]").value.trim(),
            customization: customization(),
            change,
            ...(editTicket ? {editTicket} : {}),
            attribution: campaignAttribution,
          };
          save();
        }
        await submitPending();
        void refreshCredits();
      } catch (error) {
        track("generation_request_failed", {category: error.httpStatus ? "http_" + error.httpStatus : "connection"});
        // Keep the request ID after a network failure: reconnect cannot double-charge generation.
        if (error.httpStatus && error.httpStatus < 500) {
          pending = null;
          save();
        }
        busy = false;
        stopProgress();
        if ((retrying || previousPortraitId) && sourceId && !pending) {
          portraitId = previousPortraitId || sourceId;
          completed = true;
          style = library.find(item => item.id === portraitId)?.style || style; showStyle(); syncAddress();
          restorePaintedOptions({artworkLabel: paintedName, customization: {background: paintedBackground}, expectedSubjectCount: paintedSubjectCount});
          setPhase("preview");
          await refreshPreview();
        } else {
          loading(false);
          setPhase("upload");
        }
        status(
          error.name === "AbortError"
            ? "The connection timed out. Reconnect to the same portrait below."
            : error.message,
        );
        updateControls();
        void refreshCredits();
      }
    }
    $("[data-paint]").onclick = () =>
      portraitId && !completed && !pending ? poll() : paint();
    $("[data-retry]").onclick = () => openRetry();
    $("[data-reveal-retry]").onclick = () => openRetry();
    $("[data-resume]").onclick = () => completed ? refreshPreview() : (pending ? paint() : poll());
    $("[data-adjust]").onclick = () => {
      $(".pw-change").hidden = false;
      $(".pw-change textarea").focus({ preventScroll: true });
      focusWork(".pw-change");
    };
    const editTargetLabel=document.createElement("label");
    editTargetLabel.dataset.editTargetLabel="";editTargetLabel.hidden=true;
    editTargetLabel.textContent="Who should we change?";
    const editTarget=document.createElement("select");editTarget.dataset.editTarget="";editTargetLabel.append(editTarget);
    const editPlanMessage=document.createElement("p");editPlanMessage.dataset.editPlanMessage="";editPlanMessage.className="pw-note";editPlanMessage.setAttribute("role","status");
    $(".pw-change textarea").parentElement.after(editTargetLabel,editPlanMessage);
    let editPlanning=false;
    $(".pw-change").onsubmit = async (event) => {
      event.preventDefault();
      if(editPlanning || busy || !completed)return;
      const textarea=$(".pw-change textarea"),change=textarea.value.trim();
      if(!change){editPlanMessage.textContent="Tell us what you would like to change.";return;}
      const sourceId=portraitId,requestedStyle=style,button=$(".pw-change button[type=submit]") || $(".pw-change > button");
      editPlanning=true;textarea.disabled=true;if(button)button.disabled=true;
      editPlanMessage.textContent="Checking your instructions…";
      try {
        await ensureSession();
        const plan=await api("restore",{requestId:crypto.randomUUID(),previewEdit:true,sourceId,style:requestedStyle,change,
          ...(editTarget.dataset.source===sourceId && !editTargetLabel.hidden && editTarget.value ? {editTarget:editTarget.value} : {})});
        if(portraitId!==sourceId || (isFunnel && !$("[data-edit-dialog]").open))return;
        if(!plan.editTicket)throw new Error("We could not check that edit. Please try again.");
        editPlanMessage.textContent="";
        $("[data-edit-dialog]")?.close();
        return await paint(change,plan.editTicket);
      } catch(error) {
        if(portraitId!==sourceId)return;
        editPlanMessage.textContent=error.message;
        if(error.details?.clarification && Array.isArray(error.details.subjects)) {
          editTarget.replaceChildren();
          for(const [value,label] of [["","Choose a person or pet"],["all","Everyone"],...error.details.subjects.map(s=>[s.id,s.label+(s.copies===0?" (not currently included)":"")])]) {
            const option=document.createElement("option");option.value=value;option.textContent=label;editTarget.append(option);
          }
          editTarget.dataset.source=sourceId;editTargetLabel.hidden=false;editTarget.focus();
        }
      } finally {editPlanning=false;textarea.disabled=false;if(button)button.disabled=false;}
    };
    $("[data-approve]").onclick = async () => {
      if (busy || !completed || !previewReady || artworkChanged()) return;
      approved = true;
      track("print_selected", {}, portraitId);
      setPhase("product");
      focusWork(isFunnel ? "[data-finish]" : undefined);
      await refreshPreview();
      // 3D remains optional and loads only when explicitly chosen.
      $("[data-product-choices] button")?.focus({ preventScroll: true });
    };
    function editPhotos() {
      if (busy || pending) return;
      setPhase("upload"); save();
      $("[data-photo-panel]").open = true;
      focusWork("[data-photo-panel]");
    }
    function reviewPortrait() {
      if (busy || !completed) return;
      setPhase("preview");
      void switchView("artwork");
      void refreshPreview();
      focusWork();
    }
    $("[data-edit-photos]").onclick = editPhotos;
    $("[data-return-portrait]").onclick = reviewPortrait;
    root.querySelectorAll("[data-step]").forEach(button => {
      button.onclick = () => {
        if (button.disabled) return;
        if (button.dataset.step === "upload") editPhotos();
        else if (button.dataset.step === "preview") reviewPortrait();
        else if (approved) void $("[data-approve]").onclick();
      };
    });
    function canRequestCart() {
      const id = versionTargetId || portraitId;
      return phase === "product" && Boolean(selected()) && !cartIntent && !pending && !hashing &&
        (!busy || versionLoading) && !slider?.interacting() &&
        (versionLoading ? library.some(item => item.id === id) : completed && approved && !artworkChanged());
    }
    function preparedCartItem(id, variant) {
      const key = id + ":" + variant.id + ":" + variant.price;
      const previous = preparedCartItems.get(key);
      if (previous && Date.now() - previous.created < 60000) return previous.promise;
      const entry = {created: Date.now(), promise: null};
      entry.promise = api("cart", {id, variantId: variant.id}).catch(error => {
        if (preparedCartItems.get(key) === entry) preparedCartItems.delete(key);
        throw error;
      });
      preparedCartItems.set(key, entry);
      if (preparedCartItems.size > 8) preparedCartItems.delete(preparedCartItems.keys().next().value);
      return entry.promise;
    }
    function scheduleCartPreparation(ready) {
      if (!isFunnel) return;
      const variant = selected(), id = portraitId;
      const key = ready && variant && id ? id + ":" + variant.id + ":" + variant.price : "";
      if (key === scheduledCartKey) return;
      clearTimeout(prepareCartTimer);scheduledCartKey = key;
      if (!key) return;
      // Prepare only a settled print selection. This creates no cart line and
      // fires no add-to-cart event; the explicit Add click owns that mutation.
      prepareCartTimer = setTimeout(() => {
        void preparedCartItem(id, variant).catch(() => {});
      }, 750);
    }
    $("[data-cart]").onclick = async () => {
            if(printPair?.second)return addPairToCart();
      const variant = selected(), requestedId = versionTargetId || portraitId;
      if (isFunnel ? !canRequestCart() : (!variant || !portraitId || !previewReady || !approved || busy || phase !== "product")) return;
      if (addedKey === requestedId + ":" + variant.id) {
        if (window.PawntedCart) await window.PawntedCart.open({trigger:$("[data-cart]")});
        else window.location.assign((window.Shopify?.routes?.root || "/") + "cart");
        return;
      }
      cartIntent = true;
      const controls = $(".pw-pdp-grid"); if (controls) controls.inert = true;
      updateControls();
      status("Adding your portrait…");
      if (window.PawntedCart?.finishAdd) {
        const price=Math.round(Number(variant.price)*100), artworkStyle=library.find(item=>item.id===requestedId)?.style || style;
        void window.PawntedCart.open({trigger:$("[data-cart]"),pending:true,item:{
          key:"pending:"+requestedId+":"+variant.id,variant_id:variant.id,sku:variant.sku,quantity:1,
          product_title:styleName(artworkStyle)+" · "+variant.title,
          variant_title:variant.size.replace("x"," × ")+" in · "+(variant.frameColor || (variant.productType === "canvas" ? "Canvas" : "Print")),
          price,original_line_price:price,final_line_price:price,requires_shipping:true,
          properties:{_pawnted_portrait_id:requestedId,_pawnted_base_variant:variant.id,_pawnted_preview:savedPreview(requestedId).source,"Free gift":"Digital print"},
        }});
      }
      try {
        if (isFunnel) {
          await versionTask;
          if (portraitId !== requestedId || !completed || !approved) throw new Error("This artwork could not be loaded. Please select it again.");
          // Accept the click immediately, but verify the exact clicked artwork
          // and finish before Shopify receives a cart mutation.
          await Promise.all([getTexture(requestedId), getTexture(requestedId, variant)]);
        }
        busy = true; phase = "cart"; updateControls();
        const cartRoot = window.Shopify?.routes?.root || "/";
        // Prepare checkout artwork and read the bag concurrently; both must finish before adding.
        const [item, bag] = await Promise.all([
          preparedCartItem(requestedId, variant),
          (async () => {
            const response = await fetchBounded(cartRoot + "cart.js");
            if (response && !response.ok) throw new Error("Couldn't check your bag. Please try again.");
            const bag=await response.json();window.PawntedCart?.hydrateAdd?.(bag);return bag;
          })(),
        ]);
        const alreadyAdded = bag.items?.some(line => String(line.variant_id) === String(item.id) && line.properties?._pawnted_portrait_id === requestedId);
        const response = alreadyAdded ? null : await fetchBounded(cartRoot + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [item] }),
        });
        if (response && !response.ok) {
          const problem = await response.json().catch(() => ({}));
          throw new Error(typeof problem.description === "string" ? problem.description : "Could not add to your bag. Please try again.");
        }
        recordCartArtwork(requestedId,variant.id,alreadyAdded ? "cart_observed" : "cart_added");
        const bagCount = (bag.item_count ?? bag.items?.reduce((total, line) => total + (line.quantity || 1), 0) ?? 0) + (alreadyAdded ? 0 : 1);
        document.querySelectorAll(".atelier-bag").forEach(link => { link.setAttribute("aria-label", "Shopping bag, " + bagCount + " items"); const count = link.querySelector("span"); if (count) count.textContent = String(bagCount); });
        addedKey = requestedId + ":" + variant.id;
        $("[data-added-image]").src = $(".pw-preview").src;
        $("[data-added-description]").textContent = styleName(style) + " \u00b7 " + variant.size.replace("x", " \u00d7 ") + " in \u00b7 " + (variant.frameColor || (variant.productType === "canvas" ? "Canvas" : "Print")) + " \u00b7 " + money(variant.price);
        $("[data-checkout]").href = cartRoot + "checkout";
        $("[data-view-bag]").href = cartRoot + "cart";
        busy = false; setPhase("product"); save();
        status("Added to your bag. Check out or choose another favourite.");
        if (window.PawntedCart?.finishAdd) await window.PawntedCart.finishAdd("Your portrait is in the bag.");
        else if (window.PawntedCart) await window.PawntedCart.open({trigger:$("[data-cart]"),announcement:"Your portrait is in the bag."});
        else focusWork("[data-added]");
      } catch (error) {
        busy = false;
        setPhase("product");
        status(error.message);
        if (window.PawntedCart?.finishAdd) await window.PawntedCart.finishAdd(error.message, false);
      } finally {
        cartIntent = false; if (controls) controls.inert = false; updateControls();
      }
    };
    $("[data-mobile-action]").onclick = () => {
      if (cartIntent || (busy && !versionLoading)) return;
      if (isFunnel && phase === "product") return $("[data-cart]").onclick();
      if (isFunnel && creditBalance?.total === 0 && !pending && !(portraitId && !completed) && !["preview", "product"].includes(phase)) return creditBadge.onclick();
      if (artworkChanged()) return paint();
      if (phase === "product") return $("[data-cart]").onclick();
      if (completed && phase === "preview") return $("[data-approve]").onclick();
      if (completed && phase === "upload") return reviewPortrait();
      else if (portraitId && !completed && !pending) return poll();
      else if (files.length || pending || reuseSourceId) return paint();
      else {
        $("[data-photo-panel]").open = true;
        focusWork("[data-photo-panel]");
        $("[data-files]").click();
      }
    };
    showStyle();
    setPhase(resumeOnReload && portraitId ? "product" : "upload");
    window.addEventListener("pageshow", (event) => {
      if (event.persisted && phase === "cart") {
        busy = false;
        setPhase(approved ? "product" : "preview");
        status("");
      }
    });
    // The first screen uses Shopify CDN assets, without waiting for an API/session.
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        void ensureCatalog().catch((error) => status(error.message));
      }),
    );
    void refreshCredits();
    void loadLibrary();
    if (pending) void paint();
    else if (portraitId) void (isFunnel && library.some(item => item.id === portraitId) ? resumeFinished() : poll());
  });
})();
